import {
  Button,
  FormControl,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Snackbar,
  TextField,  
  IconButton,
  Typography,
  makeStyles,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  CardMedia
} from "@material-ui/core";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Paper,
  Box,
  Drawer
} from "@mui/material";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format,differenceInCalendarDays, parseISO, formatDistance  } from "date-fns";
import { BorderBottom, SearchIcon, SearchOutlined, Translate } from '@material-ui/icons';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import MailIcon from '@mui/icons-material/Mail';
import CallIcon from '@mui/icons-material/Call';
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Alert } from "@material-ui/lab";
import * as _ from "lodash";
import React, {useEffect, useState, useRef, useMemo} from "react";
import { connect, useSelector } from "react-redux";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import * as userActions from "../actions/userActions";
import * as customerActions from "../actions/customerActions";
import * as toolsOfferedAction from "../actions/toolsOfferedAction";
import * as discountsOfferedAction from "../actions/discountsOfferedAction";
import * as toolAction from "../actions/toolAction";
import CustomButton from "../components/common/controls/CustomButton";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import DMModal from "../components/common/controls/DMModal";
import CustomerGrid from "../components/common/controls/Grid/CustomerGrid";
import DMGrid from "../components/common/controls/Grid/DMGrid";

import { orderBy } from "lodash";

import {
  deleteCustomerService,
  updateCustomerService,
  generateNewLicenseService,
  renewalLicenseService,
  updateQuantityService,
  convertLicenseService
} from "../services/CustomerServices";
import { uuidv4 } from "../utilities/applicationutils";
import "./pageStyles.scss";
import Loading from "../components/Loading/Loading";
import {
  FilterTypeGrid,  
  centerDivContainer,
  checkboxLabel,
  filterAccordionSummary,
} from "../styles";
import { getEmailSendToUser, getEmailContents } from "../services/CustomerServices";
import { DELETE_SERVICE_ERROR_MESSAGE } from "../utilities/applicationutils";
import { updateCustomerContactService } from "../services/CustomerServices";

var CONTROLS_DATA = require("./ControlsData.json");
var MODELS_CONTROLS = CONTROLS_DATA.SCREENS.CUSTOMERS;

const CUSTOMER_MANDATORY_ERR_MSG = `Mandatory fields should not be empty. Please check Mandatory fields.`;
const VALID_CUSTOMERNUMBER_ERR_MSG = `Customer number must be greater than zero.  Please respecify the customer number.`;
const CUSTOMERNUMBER_EXIST_SALESOFFICE_ERR_MSG = "Customer Number is already used for another customer of this sales office. Please specify a different Customer Number";
const CUSTOMER_INVALIDEMAIL_ERR_MSG = `Invalid Contact Email Address`;
const LICENSE_EDUCATION_DISCOUNT_ERR_MSG = `Education Discount should never have a Quantity > 1`
const LICENSE_TRIAL_QUANTITY_ERR_MSG = `Trial License should never have a Quantity > 1`

const INVOICE_NOT_EMPTY_ERR_MSG = `Invoiced Amount should not be empty`

const Customers = ({
  modelState,
  getModels,
  deleteModel,
  createNewModel,
  updateModel,
  
  onMoreOptionsSelected,
  onTabSelected,
  setSnackBar,
  onPageSelected,
  onCloseSelected,    
  toolState,
  toolsOfferedState,
  getTransactionTypesList,
  transactionTypesList,
  getDiscountsOffered,
  discountOfferedState,
  getDiscountsList,
  discountsList,
  discountsOfferedAction,
  getDiscounts,
  generateNewLicense,
  generateNewLicenseAction,
  deleteCustomerContact, 
  deleteCustomerContactAction,
  createNewLicenseAction,
  updateQuantityAction,
  createNewLicense, 
  getTools,
  getToolsOffered,
  createNewContact,
  createNewCustomer, 
  createNewContactByCustomer, 
  getCompanyTypeList,
  companyTypeList,
  expirationDatesList,
  getExpirationDatesList,
  statusList,
  getStatusList,
  getSelectedExpirationDatesData,  
  getContactsByCustomer,
  getContactsByCustomerAction,
  getCustomersList,
  customersList,
  getRenderCustomersListData,
  renderCustomersListData,  
  getSelectedMarketsData,
  getSelectedStatusData,
  expirationDateList,
  marketsCheckbox,
  expirationDateCheckbox,
  statusCheckbox,  
  updateCustomer,
  updateQuantity,   
  updateCustomerAction,
  deleteCustomerAction,
  renewalLicenseAction,
  renewalLicense,
  deleteCustomer,
  salesOfficeBasedMarketsList,
  getSalesOfficeBasedMarketsList,
  getLicenseByCustomer,  
  licenseByCustomerList,
  transactionByCustomerList,
  getTransactionByCustomer,
  contactsByCustomerList,
  updateCustomerContact,
  updateCustomerContactAction,
  salesOfficeData,
  getCurrency,
  getSalesOffice,
  currencyState,
  getSalesOfficeList,
  salesOfficeList,
  userInfo
}) => {  
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [licenseGridData, setLicenseGridData] = useState([]);
  const [transactionGridData, setTransactionGridData] = useState([]);
  const [licensePriceCalcData, setLicensePriceCalcData] = useState([]);  
  const [showRenewLicenseModel, setShowRenewLicenseModel] = useState(false);
  const [isDisabledInRenew,setIsDisabledInRenew] = useState(false);
  const [showSendEmailModel, setShowSendEmailModel] = useState(false);
  const [showNewModel, setShowNewModel] = useState(false);
  const [showNewContact, setShowNewContact] = useState(false);
  const [drawerOpen,setDrawerOpen] = useState(false);
  const [newModel, setNewModel] = useState();
  const [showNewLicenseModel, setShowNewLicenseModel] = useState(false);
  const [showEditQuantityModel, setShowEditQuantityModel]  = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isToolDisabled, setIsToolDisabled] = useState(false);
  const [selectedModel, setSelectedModel] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const retriveSalesOfficeId = localStorage.getItem("salesOfficeValue");
  //const retriveSalesOfficeId = 4;
  const toolsDropdownList = [];
  const [unsaveChangePopup, setUnsaveChangePopup] = useState(false);
  const [isUnsaveChanges, setIsUnsaveChanges] = useState(false);
  const [companyName, setCompanyName] = useState("");   
  const [salesOfficeId, setSalesOfficeId] = useState(retriveSalesOfficeId); // To do change by dynamic sales office id  
  const [expiryDateValue, setExpiryDateValue] = useState("");
  const [customerNumber, setCustomerNumber] = useState(0);
  const [companyTypeId, setCompanyTypeId] = useState("");
  const [toolId, setToolId] = useState("");
  const [licenseId, setLicenseId] = useState("");  
  const [transactionTypeId, setTransactionTypeId] = useState("");
  const [discountId, setDiscountId] = useState(0); 
  const [quantity, setQuantity] = useState(1);
  const [originalQuantity, setOriginalQuantity] = useState(0);
  const [calculatedPrice, setCalculatedPrice] = useState(0);
  const [invoicedAmount, setInvoicedAmount] = useState(0);
  const [contactName, setContactName] = useState(""); 
  const [contactEmail, setContactEmail] = useState("");
  const [jobPosition, setJobPosition] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isDefaultContact, setIsDefaultContact] = useState(false);  
  const [mainContactInfo, setMainContactInfo] = useState({});
  const [moreContactInfo, setMoreContactInfo] = useState([]);  
  const [customerContactId,setCustomerContactId] = useState("");
  const [updateOrAddCustomer, setUpdateOrAddCustomer] = useState(false);
  const [updateOrAddLicense, setUpdateOrAddLicense] = useState(false);
  const [isConvertLicense, setIsConvertLicense] = useState(false);

  const [updateOrAddContact, setUpdateOrAddContact] = useState(false);  
  const [editCustomerId,setEditCustomerId] = useState("");  
  const [renewLicenseId,setRenewLicenseId] = useState("");
  const [convertLicenseId,setConvertLicenseId] = useState("");

  const [deleteCustomerId,setDeleteCustomerId] = useState(""); 
  const [emailSendToPayload, setEmailSendToPayload] = useState({});
  const [newlicenseDiscountsIds, setNewlicenseDiscountsIds] = useState([]);
  const [renewlicenseDiscountsIds, setRenewlicenseDiscountsIds] = useState([]);
  const inputRef = useRef(null);
  const [checkExpiredLicense,setCheckedExpiredLicense] = useState([]);

  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [htmlContent, setHtmlContent] = useState('');

  const [searchValue, setSearchValue] = useState('');

  const [sortCol, setSortCol] = useState("");
  const [sortKey, setSortKey] = useState("");
  const [sortType, setSortType] = useState("");




  // Handler for sorting changes
  const handleSortChange = (col, key, type) => {
    setSortCol(col);
    setSortKey(key);
    setSortType(type);
  };

  // Sort data in parent, memoized for performance
  const sortedData = useMemo(() => {
    if (sortCol && sortKey && gridData?.length) {
      return orderBy(
        gridData,
        [(row) =>
          isNaN(row[sortKey])
            ? row[sortKey]?.toString()?.toLowerCase()
            : row[sortKey]
        ],
        [sortType]
      );
    }
    return gridData;
  }, [gridData, sortCol, sortKey, sortType]);

  const onNewProjectClick = () => {
    clearAddCustomerFields();
    clearViewSliderFields();
    setShowNewModel(true);
  }

  const onNewLicenseClick = async (e) => {
    e.stopPropagation();    
    setUpdateOrAddLicense(false);
    setIsDisabledInRenew(false);
    await Promise.all([     
      getSalesOfficeList(),
      getTransactionTypesList(), 
      getDiscountsList(),
    ]);        
    clearLicenseFields();
    setShowNewLicenseModel(true); 
  }

  const clearLicenseFields = () => {
    setToolId("");
    setTransactionTypeId("");
    setDiscountId("");
    setExpiryDateValue(dayjs(dayjs().format('YYYY-MM-DD')));
    setQuantity(1);    
    setRenewLicenseId("");
    setConvertLicenseId("");
    setLicenseId("");
    setCalculatedPrice(0);
    setInvoicedAmount(0);    
  }

  //Below is used call all the apis here
  useEffect(() => {
    const fetchAndManipulateApiData = async () => {      
      try {        
        await Promise.all([
          getSalesOfficeList(),
          getCustomersList(salesOfficeId),
          getCompanyTypeList(),
          getSalesOfficeBasedMarketsList(retriveSalesOfficeId)
        ]);
      }
      catch (error) {
        console.log('throws error while fetchandmanipulateapidata', error);
      }
    }
    fetchAndManipulateApiData();
  }, [getCustomersList,getSalesOfficeBasedMarketsList,getExpirationDatesList,getStatusList,getCompanyTypeList,getSalesOfficeList]);

  useEffect(() => {    
    const salesOfficeInfo = salesOfficeList && salesOfficeList.find((s) => s.salesOfficeId == retriveSalesOfficeId);
    const currencyObject = currencyState && currencyState?.data.find(currency => currency.currencyId === (salesOfficeInfo && salesOfficeInfo.currencyId));
    localStorage.setItem("currencySymbolValue",currencyObject?.currencySymbol);
    localStorage.setItem("currencyID",currencyObject?.currencyId);

    if(salesOfficeBasedMarketsList.length > 0){
        const updatedSelectedMarket = salesOfficeBasedMarketsList.map((item) => {
          return {
            marketId: item.marketId,
            marketName: item.marketName,            
            checked: true,
          };
        })
        getSelectedMarketsData(updatedSelectedMarket);
    }

    if(expirationDatesList.length > 0){
      const updatedSelectedExpirationDate = expirationDatesList.map((item) => {
               
        return {
          key: Math.random(),
          expiryId: item.expiryId,
          expiryName: item.expiryName, 
          expiryKey: item.expiryKey,                  
          checked: item.checked,
        };
      })
      getSelectedExpirationDatesData(updatedSelectedExpirationDate);
  }
  
  if(statusList.length > 0){
    const updatedSelectedStatus = statusList.map((item) => {
      return {
        statusId: item.statusId,
        statusName: item.statusName,
        isActive: item.isActive,          
        checked: true,
      };
    })
    getSelectedStatusData(updatedSelectedStatus);
}
  }, [salesOfficeBasedMarketsList,expirationDatesList,statusList]);

  //Below is used to manipulate the apis data to a userReder data in table
  useEffect(() => {        
      if (salesOfficeBasedMarketsList && marketsCheckbox && expirationDatesList && expirationDateCheckbox  && statusList && statusCheckbox) {
        setCheckedExpiredLicense(expirationDatesList);
        if(customersList.length > 0){
            const updateCustomers = customersList.map((cust) => {
            const markets = marketsCheckbox.find((market) => cust.marketId === market.marketId);            
            const status = statusCheckbox.find((status) => cust.isActive === status.isActive ); 
            const company = companyTypeList.find((company) => cust.companyTypeId === company.companyTypeId);
              
            const expirationDateFilter = checkExpiredLicense.map(expirationDates => {

              return expirationDates.checked && cust[expirationDates.expiryKey] ? true : false
            })
              const hasTrueValue = expirationDateFilter.some(Boolean);
            let filteredMarkets="";
            if(markets && status && company && hasTrueValue ){

              filteredMarkets = {
                customerId: cust.customerId,
                companyName: cust.companyName,
                companyTypeId: cust.companyTypeId,
                customerNumber: cust.customerNumber,
                companyType: company?.companyTypeText || "N/A",
                marketName: markets?.marketName || "N/A" ,
                status: status?.statusName || ""
              }
              //}
            }
            return filteredMarkets;          
          });
          
          const updateCustomersListData = updateCustomers.filter(obj => Object.keys(obj).length !== 0);      
          
          getRenderCustomersListData(updateCustomersListData);
      }
      else{
        getRenderCustomersListData([]);
      }
    }
  }, [salesOfficeBasedMarketsList,marketsCheckbox,statusList,statusCheckbox])


  //To handle the onChange event of Market checkbox
  const handleMarketsCheckbox = (event, data) => {
    const value = event.target.value;
    if (value === "all") {
      const updateMarketCheckBox =  salesOfficeBasedMarketsList.length === marketsCheckbox.length
          ? []
          : salesOfficeBasedMarketsList.map((item) => {
            return {
              marketId: item.marketId,
              marketName: item.marketName,
              checked: true,
            };
          })
     
updateMarketCheckBox.length === 0 ? getSelectedMarketsData(updateMarketCheckBox) : getSelectedMarketsData(updateMarketCheckBox);      
return;
    }    
    const list = [...marketsCheckbox];
    const index = list.map((item) => item.marketName).indexOf(data.marketName);
    index === -1 ? list.push(data) : list.splice(index, 1);
     
    getSelectedMarketsData(list);
  };

  //To check whether all checkboxes of Market are checked or not
  const isAllMarketsSelected = Array.isArray(salesOfficeBasedMarketsList) && Array.isArray(marketsCheckbox) &&
  salesOfficeBasedMarketsList.length > 0 &&
  marketsCheckbox.length > 0 &&
  salesOfficeBasedMarketsList.length === marketsCheckbox.length;
 

    const handleExpirationDateCheckbox = (event, data) => {
      const value = event.target.value;
      
      if (value === "all") {
        const updateExpirationDateCheckBox =   expirationDatesList.length === expirationDateCheckbox.length
            ? []
            : expirationDatesList.map((item) => {
              
              return {
                key:Math.random(),
                expiryId: item.expiryId,
                expiryName: item.expiryName,
                expiryKey: item.expiryKey,
                checked: true,
              };
            })
        
        getSelectedExpirationDatesData(updateExpirationDateCheckBox);
        return;
      }
      const list = [...expirationDateCheckbox];
      const index = list.map((item) => item.expiryName).indexOf(data.expiryName);
      index === -1 ? list.push(data) : list.splice(index, 1);
      if (expirationDatesList.length != list.length) {
        const removedItems = expirationDatesList.filter((item) => !list.some((checkbox) => checkbox.expiryId === item.expiryId));
        if (removedItems.length > 0) {
          setCheckedExpiredLicense((prevList) =>{
            return prevList.map((item) => {
              const isRemoved = removedItems.some((removed) => {
                return removed.expiryId === item.expiryId;
              })
              return { ...item, key: Math.random(), checked: isRemoved ? false : true }
            })
          })
        }
      }
      else{
        const removedItems = expirationDatesList.filter((item) => !list.some((checkbox) => checkbox.expiryId === item.expiryId));
          setCheckedExpiredLicense((prevList) =>{
            return prevList.map((item) => {
              const isRemoved = removedItems.some((removed) => {
                return removed.expiryId === item.expiryId;
              })
              return { ...item, key: Math.random(), checked: isRemoved ? false : true }
            })
          })
      }
      getSelectedExpirationDatesData(list);
    };

  useEffect(() => {
    if (customersList.length > 0) {
      const updateCustomers = customersList.map((cust) => {
        const markets = marketsCheckbox.find((market) => cust.marketId === market.marketId);
        const status = statusCheckbox.find((status) => cust.isActive === status.isActive);
        const company = companyTypeList.find((company) => cust.companyTypeId === company.companyTypeId);

        const expirationDateFilter = checkExpiredLicense.map(expirationDates => {
          return expirationDates.checked && cust[expirationDates.expiryKey]
        })

        const hasTrueValue = expirationDateFilter.some(Boolean);
        let filteredMarkets = "";
        if (markets && status && company && hasTrueValue) {

          filteredMarkets = {
            customerId: cust.customerId,
            companyName: cust.companyName,
            companyTypeId: cust.companyTypeId,
            customerNumber: cust.customerNumber,
            companyType: company?.companyTypeText || "N/A",
            marketName: markets?.marketName || "N/A",
            status: status?.statusName || ""
          }
        }
        return filteredMarkets;
      });

      const updateCustomersListData = updateCustomers.filter(obj => Object.keys(obj).length !== 0);

      getRenderCustomersListData(updateCustomersListData);
    }
  }, [checkExpiredLicense])

   
  //To handle the onChange event of Market checkbox
  const handleStatusCheckbox = (event, data) => {
    const value = event.target.value;
    if (value === "all") {
      const updateStatusCheckBox = statusList.length === statusCheckbox.length
        ? []
        : statusList.map((item) => {
          return {
            statusId: item.statusId,
            statusName: item.statusName,
            isActive: item.isActive,
            checked: true,
          };
        })


      updateStatusCheckBox.length === 0 ? getSelectedStatusData(updateStatusCheckBox) : getSelectedStatusData(updateStatusCheckBox);
      return;
    }
    const list = [...statusCheckbox];
    const index = list.map((item) => item.statusName).indexOf(data.statusName);
    index === -1 ? list.push(data) : list.splice(index, 1);
    
    getSelectedStatusData(list);
  };

  

  const onSelectedPage = (selectedPage) => {
    onPageSelected(selectedPage);
  };

  const handleNewModelName = (e) => {
    setNewModel({ ...newModel, model: e.target.value });
  };

  const handleCompanyTypeNewModel = (e) => {
    setNewModel({ ...newModel, companyTypeId: e.target.value });
  };

  const handleMarketNewModel = (e) => {
    setNewModel({ ...newModel, marketId: e.target.value });
  };  

  const handleDiscountsSelection = (e) => {

    const selectedId = e.target.value;
    setDiscountId(selectedId);

  }

  const getEditQtyDiscountsCalculatedPrice = (e) => {
    getEditQtyCalculatedPrice(e.target.value,originalQuantity,quantity);
  }




  const handleIncChangeQty = ()=>{
    // For New License page - below you can see code for edit quantity and renew license pages
    const incQuantity = quantity + 1;

    if(!licenseId){// for new license page and convert license page
      if(discountId === "" || transactionTypeId === ""){//if there is no select any discount
        setLoading(false);
        setSnackBar(true,"error",CUSTOMER_MANDATORY_ERR_MSG);
        return false;
      }

      const discId = discountId ? discountId : 0;
      if(discId > 0){
        const discountInfo = discountsList.find((discount) => discId === discount.discountId);// It should be discountList. not discountofferedstate
        if(discountInfo.discountLabel === "Educational Discount" && incQuantity > 1){//for Educational Discount - should never have a quantity > 1
          setLoading(false);
          setSnackBar(true,"error",LICENSE_EDUCATION_DISCOUNT_ERR_MSG);
          return false;
        }
      }

      const transInfo = transactionTypesList.find((trans) => transactionTypeId === trans.transactionTypeId);
      if(transInfo?.transactionTypeText === "Trial License"){
        setLoading(false);
        setSnackBar(true,"error",LICENSE_TRIAL_QUANTITY_ERR_MSG);
        return false;
      }
    }

    setQuantity(incQuantity);

    if(licenseId){
      getEditQtyCalculatedPrice(discountId,originalQuantity,incQuantity);
    }
  }

  const handleDecChangeQty = ()=>{
    const decQuantity = Math.max(1, quantity - 1);
    setQuantity(decQuantity);

    if(licenseId){
      getEditQtyCalculatedPrice(discountId,originalQuantity,decQuantity);
    }
  }

  const clearAddCustomerFields = () => {
    setCompanyName("");
    setCustomerNumber("");
    setContactName("");
    setContactEmail("");
    setJobPosition("");
    setPhoneNumber("");
    setCompanyTypeId("");   
    setNewModel({ ...newModel, marketId: "" });    
  }
  const clearViewSliderFields = () => {
    setEditCustomerId("");
  }
  const clearCustomerContact = () => {        
    setContactName("");
    setContactEmail("");
    setJobPosition("");
    setPhoneNumber("");

    setCustomerContactId("");
    setIsDefaultContact(false);  
    setUpdateOrAddContact(false);    
  }

  const toggleDrawer = (newOpen) => () => {
    clearAddCustomerFields();
    clearViewSliderFields();
    setDrawerOpen(newOpen);    
  };

  const onSendEmail = (customer) => {
    setEmailSendToPayload({
      licenseId : customer.licenseId,
      userEmail : localStorage.getItem("userEmailAddress")
    })
    callGetEmailMailContent(customer);
  }

  const callGetEmailMailContent = async (emailSendToPayload) => {
    setLoading(true)
    setShowSendEmailModel(true);
    console.log("licensePayload", emailSendToPayload);
    try{
      await getEmailContents(emailSendToPayload).then((response) => {
        const data = response.data;
        setEmail(data.sendTo);
        setSubject(data.subject);
        setHtmlContent(data.body);
        // const plainTextBody = stripHtml(data.body);
        // const mailtoLink = `https://outlook.office.com/?path=/mail/action/componse&to:${data.sendTo}?subject=${encodeURIComponent(data.subject)}&body=${encodeURIComponent(data.body)}`;
        // const mailtoLink = `mailto:${data.sendTo}?subject=${encodeURIComponent(data.subject)}&body=${encodeURIComponent(data.body)}`
        //window.location.href = mailtoLink;
        // window.open(mailtoLink, "_blank");
        setShowSendEmailModel(true);
        setLoading(false);
        // setSnackBar(true, "success", "Email sent succesfully.");
      })
      .catch((error) =>{
        setSnackBar(true,"error", error?.response?.data?.errorMessage || "Internal service problem!");
        setLoading(false);
        setShowSendEmailModel(false);
      })
    }
    catch(error){
      setLoading(false);
    }
  }

  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");

    let text = doc.body.textContent || "";

    text = text.replace(/\n/g, "%0D%0A");

    return text;
  }

  const handleEmailSendTo = async() => {
    setLoading(true)
    console.log("licensePayloadAtSend", emailSendToPayload);
    try{
      await getEmailSendToUser(emailSendToPayload).then((response) => {
      // await getEmailContents(emailSendToPayload).then((response) => {
        const data = response.data;
        // const plainTextBody = stripHtml(data.body);
        // const mailtoLink = `https://outlook.office.com/?path=/mail/action/componse&to:${data.sendTo}?subject=${encodeURIComponent(data.subject)}&body=${encodeURIComponent(data.body)}`;
        // const mailtoLink = `mailto:${data.sendTo}?subject=${encodeURIComponent(data.subject)}&body=${encodeURIComponent(data.body)}`
        //window.location.href = mailtoLink;
        // window.open(mailtoLink, "_blank");
        setShowSendEmailModel(false);
        setLoading(false);
        setSnackBar(true, "success", "Email sent succesfully.");
      })
      .catch((error) =>{
        setSnackBar(true,"error", error?.response?.data?.errorMessage || "Internal service problem!");
        setLoading(false);
        setShowSendEmailModel(false);
      })
    }
    catch(error){
      setLoading(false);
    }
  }

  const onConvertLicense = async (e, licenseInfo) =>{
    await renewLicenseCommonCode(e, licenseInfo);
    let getNewLicenseInfo;
    if(transactionTypesList.length > 0){
      getNewLicenseInfo= transactionTypesList.filter(x => x.transactionTypeText === "New License")[0];
      setTransactionTypeId(getNewLicenseInfo.transactionTypeId);
    }

    const today = dayjs()
    const oneYearFromNow = dayjs(today.add(1, "year").format("YYYY-MM-DD"));
    setExpiryDateValue(oneYearFromNow);


    setConvertLicenseId(licenseInfo.licenseId);
    setIsConvertLicense(true);


    setShowNewLicenseModel(true);


  }

  const renewLicenseCommonCode = async (e, licenseInfo) =>{
    e.stopPropagation();
    setShowNewLicenseModel(false);
    setIsDisabledInRenew(true);
    await Promise.all([
      getCurrency(),
      getSalesOfficeList(),
      getTools(),
      getTransactionTypesList(),
      getToolsOffered(retriveSalesOfficeId),
      getLicenseByCustomer(licenseInfo.customerId),
      getContactsByCustomer(licenseInfo.customerId),
      getTransactionByCustomer(licenseInfo.customerId),
    ]);
    //const discountId = licenseInfo.discountId > 0 ? licenseInfo.discountId : 0;
    const discountId = "0"; //By default shows "No Discount"
    console.log("licensePayload", licenseInfo);
    setToolId(licenseInfo.toolId);
    console.log("toolId at renewCommonCode", toolId);
    setDiscountId(discountId);


    setQuantity(licenseInfo.quantity);

    setNewModel({...newModel,toolId:licenseInfo.toolId})
    setNewModel({...newModel,discountId:licenseInfo.discountId})

  }


  const onRenewLicense = async (e,licenseInfo) => {
    await renewLicenseCommonCode(e, licenseInfo);
    let getRenewalInfo;
    if(transactionTypesList.length > 0){
     getRenewalInfo= transactionTypesList.filter(x => x.transactionTypeText === "Renewal")[0];
     setTransactionTypeId(getRenewalInfo.transactionTypeId);
    }
    setRenewLicenseId(licenseInfo.licenseId);

    let newExpirationDate = dayjs(format(licenseInfo.expirationDate, "yyyy-MM-dd")).add(1, "year")
    newExpirationDate = dayjs(newExpirationDate.format("YYYY-MM-DD"));
    setExpiryDateValue(newExpirationDate);


    setUpdateOrAddLicense(true);
    setShowNewLicenseModel(true);
  }



  useEffect(()=>{
    if(transactionByCustomerList.length > 0){
      const getTransactionByLicense = transactionByCustomerList.filter(x => x.licenseId == renewLicenseId)[0];
      if(getTransactionByLicense){
        setCalculatedPrice(getTransactionByLicense.calculatedPrice);
        setInvoicedAmount(getTransactionByLicense.amountInvoiced);
      }
    }
  },[transactionByCustomerList])

  const openNewContact = (e) => {
    e.stopPropagation();
    clearCustomerContact();
    setShowNewContact(true);
  }

  const openEditQuantity = async (e,licenseInfo) => {
    e.stopPropagation();
    clearLicenseFields();
      await Promise.all([
        getCurrency(),
        getSalesOfficeList(),
        getTools(),
        getTransactionTypesList(),
        getDiscountsList(),
        getDiscountsOffered(retriveSalesOfficeId),
        getToolsOffered(retriveSalesOfficeId),
        getLicenseByCustomer(licenseInfo.customerId),
        getContactsByCustomer(licenseInfo.customerId),
        getTransactionByCustomer(licenseInfo.customerId),
      ]);

      setLicenseId(licenseInfo.licenseId);
      setToolId(licenseInfo.toolId);

      setDiscountId(0);//for edit qty popup No Discount by default
      setTransactionTypeId(licenseInfo.transactionTypeId);
      setQuantity(licenseInfo.quantity);
      setOriginalQuantity(licenseInfo.quantity);
      const transDetails = transactionByCustomerList && transactionByCustomerList.find( details => licenseInfo.licenseId === details.licenseId)
      const calcprice = 0;
      const invoiceamt = 0;
      setCalculatedPrice(calcprice);
      setInvoicedAmount(invoiceamt);//api return invoiced amt as amontInvoiced

      setNewModel({...newModel,toolId:licenseInfo.toolId})
      setNewModel({...newModel,discountId:licenseInfo.discountId})
      setIsToolDisabled(true);

      const toolsOffersInfo =toolsOfferedState &&  toolsOfferedState.find((item) => licenseInfo.toolId === item.toolId);

      if(licenseInfo.discountId){
        const discountInfo =discountOfferedState && discountOfferedState.find((discount) => licenseInfo.discountId === discount.discountId);
        if(discountInfo.discountLabel === "Educational Discount"){//for Educational Discount - should never have a quantity > 1
          setLoading(false);
          setSnackBar(true,"error",LICENSE_EDUCATION_DISCOUNT_ERR_MSG);
          return false;
        }
      }

      const transInfo = transactionTypesList.find((trans) => licenseInfo.transactionTypeId === trans.transactionTypeId);
      if(transInfo?.transactionTypeText === "Trial License"){
        setLoading(false);
        setSnackBar(true,"error",LICENSE_TRIAL_QUANTITY_ERR_MSG);
        return false;
      }

      if(toolsOffersInfo){
        setShowNewLicenseModel(false);
        setShowEditQuantityModel(true);
      }
      else{
        if(toolsOffersInfo === undefined || toolsOffersInfo === null){
          setSnackBar(true, "error", "Tool is no longer offered by this sales office")
        }
        else{
          setSnackBar(true, "error", "Either toolsOffersInfo or discountInfo is undefined");
        }
      }
  }

  const onView = async (customer) => {
      setLoading(true);
      console.log("opened On View")
    setEditCustomerId(customer.customerId);
    setCompanyName(customer.companyName);
    setRenewLicenseId("");
    setMainContactInfo([]);
    setMoreContactInfo([]);
    try{
      await Promise.all([
        getCurrency(),
        getSalesOfficeList(),
        getToolsOffered(retriveSalesOfficeId),
        getTools(),
        //getDiscountsOffered(retriveSalesOfficeId),
        getTransactionTypesList(),
        getLicenseByCustomer(customer.customerId),
        getContactsByCustomer(customer.customerId),
        getTransactionByCustomer(customer.customerId),
      ])
      setLoading(false);
    }catch(error){
      console.log("LICENSE API FAILURE error",error)
    }
    setDrawerOpen(true);
    setLoading(false);
  }
  const onEdit = (customer) => {    
    setCompanyName(customer.companyName);
    setCustomerNumber(customer.customerNumber);
    setCompanyTypeId(customer.companyTypeId);
    setUpdateOrAddCustomer(true);

    if(companyTypeList.length > 0) {
      const companyTypeIdFind = companyTypeList.find((company) => company.companyTypeText.toLowerCase() === customer.companyType.toLowerCase());      
      setNewModel({...newModel,companyTypeId:companyTypeIdFind.companyTypeId})
    }

    if(salesOfficeBasedMarketsList.length > 0){
      const marketIdFind = salesOfficeBasedMarketsList.find((market) => market.marketName.toLowerCase() === customer.marketName.toLowerCase());    
      setNewModel({...newModel,marketId:marketIdFind.marketId})
    }
    setEditCustomerId(customer.customerId);    
    setShowNewModel(true);    
  };

  const onDelete = (customerSelected) => {
    setEditCustomerId(customerSelected?.customerId);      
    setCompanyName(customerSelected?.companyName);
    setShowDelete(true);
  };

  //Fix for Customer - Not possible to toggle customer between active and cancelled
  const isActiveCancelled = async (customerSelected) => {
    const marketIdFind = salesOfficeBasedMarketsList && salesOfficeBasedMarketsList.find((market) => market.marketName.toLowerCase() === customerSelected.marketName.toLowerCase());
    try {
      const customerPayload = {
      customerId: customerSelected?.customerId,
      companyName: customerSelected?.companyName,
      companyTypeId: customerSelected?.companyTypeId,
      customerNumber: customerSelected?.customerNumber,                
      marketId: marketIdFind?.marketId,
      isActive: customerSelected?.status === "Active" ? false : true                
  };
    await updateCustomerService(customerPayload).then( async (response) => {  
            await Promise.all([
              getSalesOfficeBasedMarketsList(retriveSalesOfficeId),
              getExpirationDatesList(),
              getStatusList(),
              getCompanyTypeList(),          
              getCustomersList(salesOfficeId),                
            ]);
            setSnackBar(true, "success", `Status updated.`);            
            clearAddCustomerFields();            
            setLoading(false);
            setUpdateOrAddCustomer(false);
            setShowNewModel(false);
          }).
          catch ((error) => {          
            setSnackBar(true,"error", error?.response?.data?.errorMessage || DELETE_SERVICE_ERROR_MESSAGE);
            setUpdateOrAddCustomer(false);            
            clearAddCustomerFields();
            setNewModel({...newModel,companyTypeId:{}, marketId:{}});
            setLoading(false);            
            setShowNewModel(false);
        })
      }
      catch (error) {
        setUpdateOrAddCustomer(false);            
        clearAddCustomerFields();
        setNewModel({...newModel,companyTypeId:{}, marketId:{}});
        setLoading(false);            
        setShowNewModel(false);
      }
  }

  const onUpdateModelName = async (value, model) => {
    const { isSame, isPresent } = isModelPresent(
      value,
      model,
      modelState.models.data
    );
    if (isSame) {
      return;
    }
    if (isPresent) {      
      setSnackBar(true, "error", "Model Name already exists");
      setGridData([]);
      setModels([...models]);
      setLicenseGridData([]);
      setTransactionGridData([]);
    } else {
      try {
        const payload = {
          modelId: model.modelId,
          modelName: value,
          companyTypeId: model.companyTypeId,
          marketId: model.marketId,
        };
        await updateModel(payload);
        if (!modelState.updateModel.hasError) {
          setSnackBar(true, "success", `Model name updated`);
          await getModels();
          setModels(modelState.models.data);
          setSnackBar(true, "success", `${value} has been updated`);
        }
      } catch (error) {
        setShowNewModel(false);
        setSnackBar(
          true,
          "error",
          `Error while updating model ${model?.model}`
        );
      }
    }
  };

  const onEditCustomerContact = async(e,customerContact)=>{
    e.stopPropagation();    
    setCustomerContactId(customerContact.customerContactId);
    setContactName(customerContact.contactName);
    setContactEmail(customerContact.contactEmail);
    setJobPosition(customerContact.role);
    setPhoneNumber(customerContact.contactPhoneNumber);
    setIsDefaultContact(customerContact.isDefaultContact);  
    setUpdateOrAddContact(true);
    setShowNewContact(true);
  }
  
  const onDeleteCustomerContact = async(e,customerContactId) =>{
    e.stopPropagation();
    try {
      await deleteCustomerContactAction({ customerContactId: customerContactId});      
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `Error while deleting model ${customerContactId}`
      );
    }
  }

  useEffect( () => {    
    if (deleteCustomerContact.hasError) {
      setSnackBar(
        true,
        "error",
        `Error while deleting customer contact`
      );
      setLoading(false);
    }else{    
      if(deleteCustomerContact.data){
        setSnackBar(  
          true, "success", `Customer contact has been deleted.`);
          getContactsByCustomer(editCustomerId);
      }
    }
  },[deleteCustomerContact]);

  useEffect( () => {
    const fetchTools = async () => {
      try {
        await getCurrency();
        await getSalesOfficeList();
        await getTools();
        await getToolsOffered(retriveSalesOfficeId);
        await getTransactionTypesList();
        await getDiscountsList();
        await getDiscountsOffered(retriveSalesOfficeId);
      } catch (error) {
        console.log("get tools fails", error);
      }
    }
    fetchTools()
  }, [getTools, getCurrency, getSalesOfficeList, getToolsOffered,getTransactionTypesList,getDiscountsList,getDiscountsOffered]);
  // render response of each row column of userDetails array object

  useEffect(()=>{      
    const callInitialAPIS = async () => {
      if(customersList.length > 0){
        try {      
          setLoading(true);
          await Promise.all([
            getSalesOfficeBasedMarketsList(salesOfficeId),
            getExpirationDatesList(),
            getStatusList(),  
            getCurrency(),
            getSalesOfficeList(),          
            getTools(),          
            getToolsOffered(retriveSalesOfficeId),
            getTransactionTypesList(),
          ]);      
          setLoading(false);
        }catch (error) {
          setLoading(false);
          console.log('throws error while call initial api', error);
        }
      }
    }
    callInitialAPIS();
  },[customersList])
  
  useEffect(() => {        
    const ctrlData = [];
    if (searchValue.length > 0) {
      onPageSelected(0);
    }
    const filteredData = renderCustomersListData.filter(model => 
      model.companyName.toLowerCase().includes(searchValue) ||
      model.customerNumber.toString().includes(searchValue) ||
      model.companyType.toLowerCase().includes(searchValue) ||
      model.marketName.toLowerCase().includes(searchValue) ||
      model.status.toLowerCase().includes(searchValue)
    );
    
      filteredData.length > 0 && filteredData.forEach((model, i) => {
      ctrlData.push({
        rowKey: model.customerId,
        companyName : model.companyName,     
        companyTypeId: model.companyTypeId,   
        companyType: model.companyType,
        customerNumber: parseInt(model.customerNumber),        
        marketName: model.marketName,
        status: model.status,
        rowValue: [
          {
            colType: "first-column-pointer",
            colOptions: {   
              name: "slide",
              width: "10px",
              value: model.companyName,
              tab: "models",
              model: model,
              action: () => onView(model),              
              onUpdate: onUpdateModelName,
            },
          },          
          {
            colType: "user-grid-label",
            colOptions: {
              width: "100px",
              value: parseInt(model.customerNumber),
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model.companyType,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "user-grid-label",
            colOptions: {
              width: "100px",
              value: model.marketName,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "first-column-pointer",
            colOptions: {
              width: "100px",
              value: model.status,
              tab: "models",
              model: model,
              action: () => isActiveCancelled(model),
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-actions",
            colOptions: [
              { name: "view", 
                tab: "drawing",  
                sidePanelContent: DrawerList,
                action: () => onView(model) },
              {
                name: "edit",
                tab: "models",
                action: () => onEdit(model),
                width: "850px",
              },
              { name: "delete", action: () => onDelete(model) }    
            ],
          },
        ],
      });
    });    
  setGridData(ctrlData);
  }, [renderCustomersListData, searchValue]);
  
  /* Grid - license by customer lists */
  useEffect(() => {
    const licenseData = [];
    licenseByCustomerList.length > 0 && licenseByCustomerList.forEach((model,i) => {
      const toolsDet = toolState.find((tool) => tool.toolId == model.toolId);
      const typesDet = transactionTypesList.find((trans) => trans.transactionTypeId == model.transactionTypeId);      
      const daysDiff = differenceInCalendarDays(
        new Date(model.expirationDate),
        new Date()
      );  
      const daysLeft =  ((daysDiff > 0) ? daysDiff : 0);   
      const formattedDate = format(model.expirationDate, "MMMM do, yyyy")+` (${daysLeft} Days Left)`;      
      console.log("type", typesDet.transactionTypeText);
      licenseData.push({
        rowKey: model.licenseId,
        licenseKey : model.licenseKey,     
        expirationDate: model.expirationDate,   
        quantity: model.quantity,
        toolId: model.toolId,  
        toolName: toolsDet.toolName,      
        type: model.type,
        customerId: model.customerId,                
        rowValue: [
          {
            colType: "user-grid-label",
            colOptions: {              
              width: "100px",
              value: toolsDet.toolName,
              tab: "models",
              model: model,              
              onUpdate: onUpdateModelName,
            },
          },          
          {
            colType: "user-grid-label",
            colOptions: {
              width: "100px",
              value: typesDet.transactionTypeText,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "first-column-pointer",
            colOptions: {              
              width: "100px",
              value: model.quantity,
              tab: "models",
              model: model,               
              action: (e) => {openEditQuantity(e,model)},
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "user-grid-label",
            colOptions: {
              width: "100px",              
              alignItems: "center",
              cellClassName: 'expiration-bgcolor',
              value: formattedDate,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          
          {
            colType: "grid-actions",
            colOptions: [
              {
                name: "email",
                tab: "models",
                action: () => onSendEmail(model),
                width: "850px",
              },
              ...(typesDet.transactionTypeText === "Trial License" ? [{
                name: "convertLicense",
                tab: "models",
                action: (e) => onConvertLicense(e,model),
                width: "850px",
              }] :[{
                name: "renewlicense",
                tab: "models",
                action: (e) => onRenewLicense(e,model),
                width: "850px",
              }])
            ],
          },
        ],
      });
    });
  
  
  setLicenseGridData(licenseData);
    
  }, [licenseByCustomerList]);

  /* Grid - transaction grid details */  
  useEffect(() => {
    var addDiscountId = [];    
    var item1 = []; item1.push({discountId: 0})//for no discount - new license
    var item2 = []; item2.push({discountId: 0})//for no discount - renew license
    discountOfferedState.length > 0 && discountOfferedState.map((discount) => {
      const discountInfo = discountsList.find((list) => discount.discountId === list.discountId);
      const transInfo = transactionTypesList.find((trans) => discountInfo.transactionTypeId === trans.transactionTypeId);
      var transType = transInfo.transactionTypeText;

      console.log("transInfo", transInfo);
      console.log("transList", transactionTypesList);
      console.log("discount", discount);
      if(transType.includes("Renewal")){
        item2.push({discountId: discount.discountId});
      }else{
        item1.push({discountId: discount.discountId});
      }
    })
    setNewlicenseDiscountsIds(item1);
    setRenewlicenseDiscountsIds(item2);

    const transactionData = [];      
    transactionByCustomerList.length > 0 && transactionByCustomerList.forEach((model,i) => {        
      const formattedDate = format(model.transactionDate, "MMMM do, yyyy");   
      const getDiscountId = (model.discountId == null ? 0 : model.discountId);      
      const discountInfo = discountOfferedState && discountOfferedState.find((discount) => getDiscountId === discount.discountId);
      const discountLabel = discountInfo && ( ((getDiscountId > 0) ? discountInfo.discountLabel : "None" ));      
      const licenseDetails = licenseByCustomerList && licenseByCustomerList.find( details => details.licenseId === model.licenseId)
      
      if(licenseDetails){
      const toolsInfo = toolState && toolState.find((item) => item.toolId === licenseDetails.toolId); 
      const transInfo = transactionTypesList && transactionTypesList.find((trans) => model.transactionTypeId === trans.transactionTypeId);  
       
      transactionData.push({
        rowKey: model.transactionId,
        transactionTypeId : model.transactionTypeId,     
        currencyId: model.currencyId,   
        amountInvoiced: model.amountInvoiced,
        discountId: getDiscountId,        
        transactionDate: model.transactionDate,  
        Quantity: model.Quantity,
        calculatedPrice: model.calculatedPrice,
        rowValue: [
          {
            colType: "user-grid-label",
            colOptions: {              
              width: "100px",
              value: formattedDate,
              tab: "models",
              model: model,              
              onUpdate: onUpdateModelName,
            },
          },          
          {
            colType: "user-grid-label",
            colOptions: {
              width: "100px",
              value: model.amountInvoiced,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: discountLabel ? discountLabel : "None",
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: toolsInfo.toolName,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "user-grid-label",
            colOptions: {
              width: "100px",
              value: transInfo.transactionTypeText,
              tab: "models",
              model: model,
              onUpdate: onUpdateModelName,
            },
          },
        ],
      });
    }
    });
  setTransactionGridData(transactionData);
  
  }, [transactionByCustomerList,licenseByCustomerList]);

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
      maxHeight: '80% !important'
    };
  }
  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "80%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 222,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "30% 17% 15% 20% 10% 8%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Roboto",
      fontWeight: "500",
      paddingLeft: 5
    },
    slideHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "30% 17% 10% 35% 8%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Roboto",
      fontWeight: "500",
      height: "30px",
      margin:0,
      paddingLeft:"30px",
      borderBottom: '1px solid #eee'
    },
    
    transactionHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "20% 15% 25% 35% 15%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Roboto",
      fontWeight: "500",
      height: "30px",
      margin:0,
      paddingLeft:"30px",
      borderBottom: '1px solid #eee'
    },

    disableClicks: {
      display: "none"
    },
    
    emailCardPaper: {
      position: "absolute",
      width: "60%",
      backgroundColor: "#F0F0F4",
      padding: "15px 15px 15px",
      height: "80%",
      overflowY: "auto"
    },
    cardContainer: {
      position: "absolute",
      width: "95%",
      backgroundColor: theme.palette.background.paper,
      // padding: theme.spacing(2, 4, 3),
      padding: "5px 5px 5px",
      height: "60%",
      overflowY: "auto"
    },
    buttonStyle: {
      marginTop: "415px"
    },
    headerLabelStyle: {
      color:"#152C73",
      fontFamily: "Roboto",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "normal"
    },
    ardPaper: {
      position: "absolute",
      width: "70%",
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "70%",
      overflowY: "auto"
    },
  }));

  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const isModelPresent = (modelName, selectedModel, data) => {
    let isPresent = false;

    if (modelName === selectedModel.modelName) {
      return { isSame: true, isPresent };
    }

    for (let model of data) {
      if (
        modelName.toLowerCase() == model.modelName.toLowerCase() &&
        selectedModel.companyTypeId == model.companyTypeId
      ) {
        isPresent = true;
        break;
      }
    }

    return { isSame: false, isPresent };
  };

  const isModelPresentInNew = (update,customerNumber, data) => {
    let isPresent = false;
    for (let customer of data) {      
      if(update){
        if (editCustomerId != customer.customerId && customerNumber == customer.customerNumber) {
          isPresent = true;
          break;
        }
      }else{
        if (customerNumber == customer.customerNumber) {
          isPresent = true;
          break;
        }
      }
    }    
    return isPresent;
  };



  const handleEditLicenseQuantity = async () => {
    setLoading(true);
    if((parseInt(calculatedPrice) > 0 && parseInt(invoicedAmount) >= 0) || (parseInt(calculatedPrice) == 0 && parseInt(invoicedAmount) == 0)){
      try {
        const editQuantityPayload = {
          amountInvoiced: invoicedAmount,
          calculatedPrice: calculatedPrice,
          discountId: ( discountId > 0 ? discountId : null),
          currencyId: localStorage.getItem("currencyID"),
          Quantity: quantity,
          licenseId: licenseId,
          transactionTypeId: transactionTypeId
        }
        const paramsPayload = {
          licenseId: licenseId,
          newQuantity: quantity
        }
      //await updateQuantityAction(editQuantityPayload,paramsPayload);
        await updateQuantityService(editQuantityPayload,paramsPayload).then( async (response) => {
          setSnackBar(true, "success", `Updating of License quantity successfully`);
          setUpdateOrAddLicense(false);
          setShowNewLicenseModel(false);
          handleCloseEditQuantityModel(false);
          setLoading(false);
          setDrawerOpen(true);
          getLicenseByCustomer(editCustomerId);
          getContactsByCustomer(editCustomerId);
          getTransactionByCustomer(editCustomerId);
        })
        .catch((error) =>{
          setSnackBar(true,"error", error?.response?.data?.errorMessage || `API Error while updating license quantity`);
          setLoading(false);
        })
      } catch (error) {
        handleCloseEditQuantityModel(false);
        setSnackBar(
          true,
          "error",
          `Error while updating license quantity`
        );
        setLoading(false);
      }
    }else {
      if(isNaN(parseInt(invoicedAmount))){
        setLoading(false);
      setSnackBar(true,"error","Invoiced Amount should not be empty");
      return false;
      }
      else{
        setLoading(false);
      setSnackBar(true,"error","Invoiced Amount should not be 0");
      return false;
      }
    }
  }

  const handleNewContact = async () => {
    setLoading(true);
    const validDetails = checkValidationForCustomerContact();
    if(validDetails){
      if(updateOrAddContact){
        try{
          const updatePayload = {
              customerContactId: customerContactId,
              customerId: editCustomerId,
              contactName: contactName,
              contactEmail: contactEmail,
              IsDefaultContact: isDefaultContact,
              role: jobPosition,
              contactPhoneNumber: phoneNumber,
          }
          //await updateCustomerContactAction(updatePayload);
          await updateCustomerContactService(updatePayload)
              .then((response) => {
                setSnackBar(
                  true, "success", `Updated Contact Details`);
                getContactsByCustomer(editCustomerId);
                setShowNewContact(false);
                setLoading(false);
                setDrawerOpen(true);
              })
              .catch((error) => {
                setSnackBar(
                        true,
                        "error",
                        `Error while updating a contact`
                      );
                      setLoading(false);
                      setDrawerOpen(false);
              })
        }catch(error){
          setShowNewContact(false);
          setSnackBar(
            true,
            "error",
            `Error while updating a contact`
          );
          setLoading(false);
        }
      }else{
        try{
          const contactPayload = {
              customerId: editCustomerId,
              contactName: contactName,
              contactEmail: contactEmail,
              IsDefaultContact: isDefaultContact,
              role: jobPosition,
              contactPhoneNumber: phoneNumber,
          }
          await createNewContactByCustomer(contactPayload);
        }catch(error){
          setShowNewContact(false);
          setSnackBar(
            true,
            "error",
            `Error while creating a new contact`
          );
          setLoading(false);
        }
      }
    }
  }


  useEffect( () => {
   if (createNewContact.hasError) {
     setSnackBar(
       true,
       "error",
       `Error while creating a new contact`
     );
     setLoading(false);
   }else{    
     if(createNewContact.data){
       setSnackBar(  
         true, "success", `Created new Contact`);
       //setDrawerOpen(true);        
       //getLicenseByCustomer(createNewContact.data.customerId);
       getContactsByCustomer(createNewContact.data.customerId);
       //getTransactionByCustomer(createNewContact.data.customerId);
       setShowNewContact(false);
       setLoading(false);
     }
   }
 },[createNewContact]);

  // For Edit Quantity Page
  const getEditQtyCalculatedPrice = (discountId,prevQty,newQty) => {
    setDiscountId(discountId);
    const toolsOffersInfo = toolsOfferedState.find((item) => toolId === item.toolId);
    if(toolsOffersInfo){
      const transInfo = transactionTypesList.find((trans) => transactionTypeId === trans.transactionTypeId);
      const transType = transInfo && transInfo.transactionTypeText;
      var fee = 0;
      /*if(transType == "New License")  fee = toolsOffersInfo.firstYearFee;
      else if(transType == "Trial License") fee = 0;
      else if(transType == "Renewal") fee = toolsOffersInfo.renewalFee;*/
      fee = toolsOffersInfo.firstYearFee;
      let discPerc = 0; let freeOfCost = 0;  let calculatedPrice = 0;
        const diff = (newQty - prevQty);
        const discountInfo = discountsList.find((discount) => discountId === discount.discountId);// It should be discountList. not discountofferedstate

        if(diff > 0){
          if(!parseInt(discountId)){// No Discount
            discPerc = 50;
            calculatedPrice = discountForMultiQty(fee,diff);
          }else if(discountInfo.discountPercentage == 100){// 100% offered
            discPerc = discountInfo.discountPercentage;
            calculatedPrice = 0;
          }else{
            discPerc = 50;
            calculatedPrice = discountForMultiQty(fee,diff);
            /*if(!parseInt(discountId)){// No Discount
              discPerc = 0;
              calculatedPrice = createLicensePriceDetails(fee,discPerc,newQty);
            }else{
              //price for only additional quantities
              calculatedPrice = discountForMultiQty(fee,diff);
            } */
          }
        }else{
          discPerc = 100;
          calculatedPrice = 0
        }

        const ctrlData = [];
        const priceDetails = {
          "firstYearFee": toolsOffersInfo.firstYearFee,
          "renewalFee": toolsOffersInfo.renewalFee,
          "feeValue": fee,
          "discountPercentage": discPerc,
          "quantity": newQty,
        };
      ctrlData.push(priceDetails);
      setLicensePriceCalcData(ctrlData);
      setCalculatedPrice(calculatedPrice);
      setInvoicedAmount(calculatedPrice);
    }
  }

  const discountForMultiQty =  (feeValue,qtyChange) => {
    const calculatedPrice = feeValue * 0.5 * qtyChange;
    return calculatedPrice;
  }


  useEffect(function calculatePrice(){
    if(licenseId) return;
    let transType = "New License";
    let firstYearFee = 0;
    let renewalFee = 0;

    console.log("toolId", toolId);

    if(toolId){
      const toolsOffersInfo = toolsOfferedState && toolsOfferedState.find((item) => toolId === item.toolId);
      if(toolsOffersInfo){
        firstYearFee = toolsOffersInfo.firstYearFee;
        renewalFee = toolsOffersInfo.renewalFee;
      }
    }
    console.log(" renewal fee", renewalFee);

    if(transactionTypeId){
      const transInfo = transactionTypesList.find((trans) => transactionTypeId === trans.transactionTypeId);
      transType = transInfo && transInfo.transactionTypeText;
    }

    let discPerc = 0;
    let calculatedPrice = 0;
    if(discountId > 0 ){
      const discountInfo = discountsList.find((discount) => discountId === discount.discountId);
      discPerc = discountInfo.discountPercentage;
    }

    if(transType === "New License" && discPerc !== 100)  calculatedPrice = (firstYearFee) * ((100 - discPerc) / 100) + (firstYearFee) * 0.5 * (quantity - 1);
    else if(transType === "Renewal" && discPerc !== 100) calculatedPrice = renewalFee * quantity;

    console.log("price at renewal", calculatedPrice)

    setCalculatedPrice(calculatedPrice);
    setInvoicedAmount(calculatedPrice);

  }, [toolId, quantity, discountId, transactionTypeId, licenseId])


  const handleCreateLicense = async () => {
    setLoading(true);
    const validDetails = checkValidationForLicense();
    if(validDetails) {
      if(updateOrAddLicense){
        try{
          const licensePayload = {
              licenseId: renewLicenseId,
              amountInvoiced: invoicedAmount,
              calculatedPrice: calculatedPrice,
              discountId: (discountId > 0 ? discountId : null),
              currencyId: localStorage.getItem("currencyID"),
              transactionTypeId: transactionTypeId,
              Quantity: quantity,
              toolId: toolId,
              expirationDate: new Date(expiryDateValue).toISOString(),
              customerId: editCustomerId
          }
          //await renewalLicenseAction(licensePayload);
          await renewalLicenseService(licensePayload).then( async (response) => {
            setSnackBar(true, "success", `License renewed successfully`);
            setIsDisabledInRenew(false);
            setUpdateOrAddLicense(false);
            setShowNewLicenseModel(false);
            setLoading(false);
            setDrawerOpen(true);
            getLicenseByCustomer(editCustomerId);
            getContactsByCustomer(editCustomerId);
            getTransactionByCustomer(editCustomerId);
          })
          .catch((error) =>{
            setSnackBar(true,"error", error?.response?.data?.errorMessage);
            setLoading(false);
          })
        }catch(error){
          setShowNewLicenseModel(false);
          setSnackBar(
            true,
            "error",
            `Error while renewal of license`
          );
          setLoading(false);
        }
      }
      else if(isConvertLicense){
        try{
          const licensePayload = {
            licenseId: convertLicenseId,
            amountInvoiced: invoicedAmount,
            calculatedPrice: calculatedPrice,
            discountId: (discountId > 0 ? discountId : null),
            currencyId: localStorage.getItem("currencyID"),
            transactionTypeId: transactionTypeId,
            Quantity: quantity,
            toolId: toolId,
            expirationDate: new Date(expiryDateValue).toISOString(),
            customerId: editCustomerId
          }
          //await renewalLicenseAction(licensePayload);
          await convertLicenseService(licensePayload).then( async (response) => {
            setSnackBar(true, "success", `License renewed successfully`);
            setIsDisabledInRenew(false);
            setIsConvertLicense(false);
            setShowNewLicenseModel(false);
            setLoading(false);
            setDrawerOpen(true);
            getLicenseByCustomer(editCustomerId);
            getContactsByCustomer(editCustomerId);
            getTransactionByCustomer(editCustomerId);
          })
            .catch((error) =>{
              setSnackBar(true,"error", error?.response?.data?.errorMessage);
              setLoading(false);
            })
        }catch(error){
          setShowNewLicenseModel(false);
          setSnackBar(
            true,
            "error",
            `Error while renewal of license`
          );
          setLoading(false);
        }
      }
      else{
        try{
          const licensePayload = {
              amountInvoiced: invoicedAmount,
              calculatedPrice: calculatedPrice,
              discountId: (discountId > 0 ? discountId : null),
              currencyId: localStorage.getItem("currencyID"),
              transactionTypeId: transactionTypeId,
              Quantity: quantity,
              toolId: toolId,
              expirationDate: new Date(expiryDateValue).toISOString(),
              customerId: editCustomerId
          }
          //await generateNewLicenseAction(licensePayload);
          await generateNewLicenseService(licensePayload).then( async (response) => {
                setSnackBar(true, "success", `Created new License`);
                getLicenseByCustomer(editCustomerId);
                getContactsByCustomer(editCustomerId);
                getTransactionByCustomer(editCustomerId);
                setLoading(false);
                setShowNewLicenseModel(false);
              })
              .catch((error) =>{
                setSnackBar(true,"error", error?.response?.data?.errorMessage);
                setLoading(false);
              })
        }catch(error){
          setShowNewLicenseModel(false);
          setSnackBar(
            true,
            "error",
            `Error while creating a new license`
          );
          setLoading(false);
        }
      }
    }
  }

  useEffect(()=>{
    if(contactsByCustomerList.length>0){
      const contactInfo = contactsByCustomerList.find((contacts) => contacts.isDefaultContact == true);
      setMainContactInfo(contactInfo);
      const data = [];
      contactsByCustomerList.map((contact,i)=>{
        if(contact.isDefaultContact==false) {
          data.push(contact);
        }
      })
      setMoreContactInfo(data);
    }
  },[contactsByCustomerList])

  const checkValidationForCustomerContact = () => {
    if(!contactName || !contactEmail){
      setLoading(false);
      setSnackBar(true,"error",CUSTOMER_MANDATORY_ERR_MSG);
      return false;
    }else if(contactEmail != ""){
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,20})$/;
      if(!reg.test(contactEmail)){
        setLoading(false);
        setSnackBar(true,"error",CUSTOMER_INVALIDEMAIL_ERR_MSG);
        return false;
      }else return true;
    }else return true;
  }

  const checkValidationForLicense = () => {
    if(updateOrAddLicense){
      if(!expiryDateValue || discountId == "" || !quantity || isNaN(parseInt(invoicedAmount))){
        setLoading(false);
        setSnackBar(true,"error",CUSTOMER_MANDATORY_ERR_MSG);
        return false;
      }
      else if(parseInt(discountId) == 0 ){
        if(parseInt(invoicedAmount) >= 0){
          return true
        }
        else{
          setLoading(false);//No Discount - does not allow invoiced amount as 0 or empty
          setSnackBar(true,"error",INVOICE_NOT_EMPTY_ERR_MSG);
          return false;
        }
      }
      else if(parseInt(discountId) > 0 && parseInt(invoicedAmount) > 0){
        setLoading(false);//100% - might be allow as price 0 but not empty
        setSnackBar(true,"error","Invoice Amount should not be greater than 0");
        return false;
      }
      else return true;
    }
    else{
      if (!toolId || !transactionTypeId || !expiryDateValue || discountId == "" || !quantity || isNaN(parseInt(invoicedAmount))) {
        setLoading(false);
        setSnackBar(true, "error", CUSTOMER_MANDATORY_ERR_MSG);
        return false;
      }
      else if (parseInt(discountId) == 0) {
        const transInfo = transactionTypesList.find((trans) => transactionTypeId === trans.transactionTypeId);
        if (transInfo?.transactionTypeText == "Trial License" && parseInt(invoicedAmount) >= 0) {
          return true
        }
        else if (transInfo?.transactionTypeText == "New License" && parseInt(invoicedAmount) >= 0) {
          return true
        }
        else {
          setLoading(false);//No Discount - does not allow invoiced amount as 0 or empty
          setSnackBar(true, "error", "Invoice amount should be greater than 0");
          return false;
        }
      }
      else if (discountId > 0) {
        const transInfo = transactionTypesList.find((trans) => transactionTypeId === trans.transactionTypeId);
        if (transInfo?.transactionTypeText == "Trial License" && parseInt(invoicedAmount) >= 0) {
          return true
        }
        else if (transInfo?.transactionTypeText == "New License") {

          const discountInfo = discountsList.find((discount) => discountId === discount.discountId);// It should be discountList. not discountofferedstate
          if (discountInfo.discountPercentage == 100 && parseInt(invoicedAmount) > 0) {
            setLoading(false);
            setSnackBar(true, "error", "Invoice Amount should not be greater than 0");
            return false;
          }
          else if (discountInfo.discountLabel == "Educational Discount") {//for Educational Discount - should never have a quantity > 1
            if(quantity > 1){
              setLoading(false);
              setSnackBar(true, "error", LICENSE_EDUCATION_DISCOUNT_ERR_MSG);
              return false;
            }
            else if(parseInt(invoicedAmount) <= 0){
              setLoading(false);
              setSnackBar(true, "error", "Invoice Amount should not be 0");
              return false;
            }
            else{
              return true
            }
          }
          else if(discountInfo.discountPercentage > 0 && discountInfo.discountPercentage < 100){
            if(parseInt(invoicedAmount) < 0){
              setLoading(false);
              setSnackBar(true, "error", "Invoice Amount shoule be greater than 0");
              return false;
            }
            else{
              return true
            }
          }
          else {
            return true
          }
        }
      } else {
        return true;
      }
    }
  }

  const checkValidationForCustomer = () => {
    const isPresent = isModelPresentInNew(
      updateOrAddCustomer,
      customerNumber,
      renderCustomersListData
    );

    if(updateOrAddCustomer){
      if(!companyName || !customerNumber || !companyTypeId || !newModel?.marketId){
        setLoading(false);
        setSnackBar(true,"error",CUSTOMER_MANDATORY_ERR_MSG);
        return false;
      }else if(customerNumber < 1){
        setLoading(false);
        setSnackBar(true,"error",VALID_CUSTOMERNUMBER_ERR_MSG);
        return false;
      }else if (isPresent) {
        setLoading(false);
        setSnackBar(true, "error", CUSTOMERNUMBER_EXIST_SALESOFFICE_ERR_MSG);
        return false;
      }else return true;
    }else{
      if(!companyName || !customerNumber || !companyTypeId || !newModel?.marketId || !contactName || !contactEmail){
        setLoading(false);
        setSnackBar(true,"error",CUSTOMER_MANDATORY_ERR_MSG);
        return false;
      }else if(customerNumber < 1){
        setLoading(false);
        setSnackBar(true,"error",VALID_CUSTOMERNUMBER_ERR_MSG);
        return false;
      }else if (isPresent) {
        setLoading(false);
        setSnackBar(true, "error", CUSTOMERNUMBER_EXIST_SALESOFFICE_ERR_MSG);
        return false;
      }else if(contactEmail != ""){
        var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,20})$/;
        if(!reg.test(contactEmail)){
          setLoading(false);
          setSnackBar(true,"error",CUSTOMER_INVALIDEMAIL_ERR_MSG);
          return false;
        }else return true;
      }else return true;
    }
  }

  const handleCreateModel = async () => {
    const validDetails = checkValidationForCustomer();    
    if(validDetails){      
      if(updateOrAddCustomer){      
        try {
            const customerPayload = {
                customerId: editCustomerId,
                companyName: companyName.charAt(0).toUpperCase() + companyName.slice(1),
                companyTypeId: companyTypeId,
                customerNumber: customerNumber,                
                marketId: newModel?.marketId,
                isActive: true                
            };
      
            const contactPayload = {
              contactName: contactName,
              contactEmail: contactEmail,
              IsDefaultContact: true,
              role: jobPosition,
              contactPhoneNumber: phoneNumber
            }
      
            const finalPayload = {
              customer: customerPayload,
              customerContact: contactPayload
            }
                            
          await updateCustomerAction(customerPayload);
      
          if (!updateCustomer.hasError) {
            await Promise.all([
                getCustomersList(salesOfficeId),                
                getSalesOfficeBasedMarketsList(salesOfficeId),
                getExpirationDatesList(),
                getStatusList(),
                getCompanyTypeList(),          
            ]);
            setSnackBar(true, "success", `Updated customer: ${companyName}`);            
            clearAddCustomerFields();            
            setLoading(false);
            setUpdateOrAddCustomer(false);
            setShowNewModel(false);
          }
        } catch (error) {          
          setSnackBar(
            true,
            "error",
            `Error while creating a new model ${companyName}`
          );
            setUpdateOrAddCustomer(false);            
            clearAddCustomerFields();
            setNewModel({...newModel,companyTypeId:{}, marketId:{}});
            setLoading(false);            
            setShowNewModel(false);
        }      
      }else{       
        try {
            const customerPayload = {                
                companyName: companyName.charAt(0).toUpperCase() + companyName.slice(1),
                companyTypeId: companyTypeId,
                customerNumber: customerNumber,                
                marketId: newModel?.marketId,
                isActive: true                
              };
            const contactPayload = {
              contactName: contactName,
              contactEmail: contactEmail,
              IsDefaultContact: true,
              role: jobPosition,
              contactPhoneNumber: phoneNumber
            }
            const finalPayload = {
              customer: customerPayload,
              customerContact: contactPayload
            }              
          await createNewCustomer(finalPayload);
      
          if (!createNewCustomer.hasError) {
            await Promise.all([
                getCustomersList(salesOfficeId),                
                getSalesOfficeBasedMarketsList(salesOfficeId),
                getExpirationDatesList(),
                getStatusList(),
                getCompanyTypeList(),          
            ]);
            setSnackBar(true, "success", `Created new customer: ${companyName}`);            
            clearAddCustomerFields();
            setNewModel({...newModel,companyTypeId:{}, marketId:{}});
            setLoading(false);            
            setShowNewModel(false);            
          }
        } catch (error) {
          setShowNewModel(false);
          setSnackBar(
            true,
            "error",
            `Error while creating a new model ${newModel?.model}`
          );
        }      
      }  
    }
  };

  /*Fix for https://carrierengg.atlassian.net/browse/EDESIGN-12858 */
  const deleteConfirm = async (customerDelete) => {    
    try {
      setLoading(true);   
      await deleteCustomerService({ customerId: editCustomerId }).then( async (response) => {            
            setSnackBar(true, "success", `${companyName} has been deleted.`);
            await getCustomersList(salesOfficeId);
            setLoading(false);
            setShowDelete(false);
          })
          .catch((error) =>{
            setSnackBar(true,"error", error?.response?.data?.errorMessage);
            setLoading(false);
            setShowDelete(false);
          })
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `Error while deleting model ${customerDelete.companyName}`
      );
      setLoading(false);
    }
  };  
  
  toolsOfferedState.map((item) => {
    const toolInfo = toolState.find((tool) => item.toolId == tool.toolId);
    if(toolInfo) toolsDropdownList.push(toolInfo);
  })

  /* LICENSE DETAILS IN DRAWER */
  const DrawerList = (
    <Box sx={{ width: 850,height:'100%',background: '#fff',overflowY: 'scroll'}} role="presentation" onClick={toggleDrawer(false)}>
     <Grid container item xs={9} md={9} className="page-menu license-slide">
          {/* <Card style= {{ width: '100%', padding: 10 }}>  */}

        <div className="container"  style={{display: "flex", flexDirection: "row",border:'1px solid grey',height: '40px'}}>
          <div  className="licenseCustomerIcon">
          <ArrowForwardIosIcon className="arrowIcon"/>
          </div>
          <div style={{display: "flex",flexDirection:"column",width: '30%',padding: '10px'}}>
          <Typography className="licenseheader" gutterBottom>{companyName}</Typography>                       
          </div>
        </div>
          {/* License Details */}
          <Box style={{width: "100%", display: "flex", justifyContent: "left", alignItems: "center",marginTop:25,paddingLeft:30}}>
             <Typography className="licenseheader" gutterBottom>Licenses ({licenseGridData?.length})</Typography>                       
          </Box>         .
          
          <Grid item container xs={12} md={11} justify="flex-end">
            <CustomButton
              id="newModel"
              showGradient={true}
              variant="contained"
              color="primary"
              disabled={false}
              name="New License"              
              onClick={onNewLicenseClick}
            />
          </Grid>
          {licenseGridData?.length == 0 &&      
          <Grid item container xs={12} md={11}>
            <Typography className="license-noresults" gutterBottom sx={{paddingLeft:10}}>No Results Found</Typography>
          </Grid>
          }
          <Grid item container xs={12} md={11}>
            {licenseGridData?.length > 0 && (
              <DMGrid
                key={Math.random()}
                headers={MODELS_CONTROLS.SLIDE_HEADERS}
                headerClassName={classes.slideHeaderColumns}
                data={licenseGridData}
                loading={loading}
                selectedPage={modelState.selectedPage}
                onPageSelection={onSelectedPage}
              />
            )} </Grid>
             {/* CONTACT INFO */} 
            <Box style={{width: "100%", display: "flex", justifyContent: "left", alignItems: "center",marginTop:20,paddingLeft:30, PointerEvent:"auto"}}>
              <Typography className="licenseheader" gutterBottom>Contact Info</Typography> 
              {contactsByCustomerList?.length < 3 && (
              <AddRoundedIcon style={{backgroundColor: '#8080802e',marginLeft:30,cursor:'pointer'}} onClick={(e) => {openNewContact(e);} }/>      
              )}
            </Box>  
            
            <Card style={{ border:'1px solid blue',minWidth: 250,height:130,marginLeft:30,marginTop:5 ,padding:'0px !important'}}>
            <CardHeader
title={
         <Typography gutterBottom className="maincontactTitle" >Main Contact</Typography>
      } />      
      <CardContent style={{padding:0}}>
        <div style={{ display: "flex", flexDirection: "row",paddingLeft: 5}}>
          <div style={{ display: "flex", flexDirection: "column",width:'200px'}}>
            <Typography gutterBottom style={{ color: 'text.secondary', fontSize: 14 }}>
              {mainContactInfo.contactName}
            </Typography>        
          </div>
          <div style={{ display: "flex", flexDirection: "column"}}>
            <Typography gutterBottom style={{ color: 'text.secondary', fontSize: 14 }}>
              <EditIcon  style={{fontSize: '14px',cursor:'pointer'}} onClick={(e)=>onEditCustomerContact(e,mainContactInfo)}/>
            </Typography>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "row",paddingLeft: 5}}>
          <div style={{ display: "flex", flexDirection: "column",alignContent: 'flex-start',width:'200px'}}>
            <Typography gutterBottom style={{fontSize: 14 }}>
              {mainContactInfo.role ? mainContactInfo.role : "N/A"}
            </Typography>        
          </div>
          <div style={{ display: "flex", flexDirection: "column",alignContent: 'flex-end'}}>
            <Typography gutterBottom style={{fontSize: 14 }}>
              <DeleteIcon  style={{fontSize: '14px',cursor:'pointer'}}/>
            </Typography>
          </div>
        </div>        
      </CardContent>
      <CardActions style={{padding:0}}>
      <div style={{ display: "flex", flexDirection: "row"}}>          
          <CallIcon style={{color:'blue',fontSize: '14px',paddingLeft:5,paddingTop:4}} /> 
          <Typography gutterBottom style={{ color: '#1891F6', fontSize: 14 }}>{mainContactInfo.contactPhoneNumber}</Typography>
      </div>      
      </CardActions>
      <CardActions style={{padding:0}}>
        <div style={{ display: "flex", flexDirection: "row"}}>
          <MailIcon style={{fontSize:'14px',paddingTop:4,paddingLeft:5}} />
            <Typography gutterBottom style={{ color: '#1891F6', fontSize: 14,paddingLeft:5 }}>{mainContactInfo.contactEmail}</Typography>
        </div>
      </CardActions>
    </Card>       
    {/* For moreContactInfo */}
    {moreContactInfo.map((morecontact)=>{
      return (
<Card style={{ border:'1px solid grey',minWidth: 250,height:130,marginLeft:30,marginTop:5 ,padding:'0px !important'}}>            
<CardHeader
title={
         <Typography gutterBottom style={{backgroundColor: '#fff',height:20}} ></Typography>
      } />    
      <CardContent style={{padding:0}}>
        <div style={{ display: "flex", flexDirection: "row",paddingLeft: 5}}>
          <div style={{ display: "flex", flexDirection: "column",width:'200px'}}>
            <Typography gutterBottom style={{ color: 'text.secondary', fontSize: 14 }}>
              {morecontact.contactName}
            </Typography>        
          </div>
          <div style={{ display: "flex", flexDirection: "column"}}>
            <Typography gutterBottom style={{ color: 'text.secondary', fontSize: 14 }}>
              <EditIcon  style={{fontSize: '14px',cursor:'pointer'}} onClick={(e)=>onEditCustomerContact(e,morecontact)}/>
            </Typography>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "row",paddingLeft: 5}}>
          <div style={{ display: "flex", flexDirection: "column",alignContent: 'flex-start',width:'200px'}}>
            <Typography gutterBottom style={{fontSize: 14 }}>
              {morecontact?.role || "N/A"}
            </Typography>       
          </div>
          <div style={{ display: "flex", flexDirection: "column",alignContent: 'flex-end'}}>
            <Typography gutterBottom style={{fontSize: 14 }}>
              <DeleteIcon  style={{fontSize: '14px',cursor:'pointer'}} onClick={(e) => {onDeleteCustomerContact(e,morecontact.customerContactId);}} />
            </Typography>
          </div>
        </div>        
      </CardContent>
      <CardActions style={{padding:0}}>
      <div style={{ display: "flex", flexDirection: "row"}}>          
          <CallIcon style={{color:'blue',fontSize: '14px',paddingLeft:5,paddingTop:4}} /> 
          <Typography gutterBottom style={{ color: '#1891F6', fontSize: 14,paddingLeft:5 }}>{morecontact.contactPhoneNumber}</Typography>
      </div>      
      </CardActions>
      <CardActions style={{padding:0}}>
        <div style={{ display: "flex", flexDirection: "row"}}>
          <MailIcon style={{fontSize:'14px',paddingLeft:5,paddingTop:4}} /> 
            <Typography gutterBottom style={{ color: '#1891F6', fontSize: 14,paddingLeft:5 }}>{morecontact.contactEmail}</Typography>
        </div>
      </CardActions>
    </Card> 
      )
    })}
    


             {/* For Transaction History */}
             <Box style={{width: "100%", display: "flex", justifyContent: "left", alignItems: "center",marginTop:10,paddingLeft:30,color:'#00a9ff',textDecoration:'underline'}}>
             <Typography className="transactionheader" gutterBottom>Transaction History</Typography>
            </Box>
                {transactionGridData?.length == 0 &&      
                <Grid item container xs={12} md={11}>
                  <Typography className="transaction-noresults" gutterBottom sx={{paddingLeft:10}}>No Results Found</Typography>
                </Grid>
                }
              <Grid item container xs={12} md={11}>
                {transactionGridData?.length > 0 && (
                  <DMGrid
                    key={Math.random()}
                    headers={MODELS_CONTROLS.TRANSACTION_HEADERS}
                    headerClassName={classes.transactionHeaderColumns}
                    data={transactionGridData}
                    loading={loading}
                    selectedPage={modelState.selectedPage}
                    onPageSelection={onSelectedPage}
                  />
                )} </Grid> 
          


          {/* </Card> */}
        </Grid>
    </Box>
  );

    const updatePropertyName = (inputArray, oldPropertyName, newPropertyName) => {
    const updatedArray = inputArray?.map((obj) => {
      const { [oldPropertyName]: propertyValue, ...rest } = obj;
      return {
        [newPropertyName]: propertyValue,
        ...rest,
      };
    });
    return updatedArray;
  };



  //Fix for https://carrierengg.atlassian.net/browse/EDESIGN-12863
  const handleToolSelection = (e) => {
    const selectedId = e.target.value;
    const isToolSelected = licenseByCustomerList && licenseByCustomerList.some((tool) => tool.toolId === selectedId);
    if (isToolSelected) {
      setToolId("");
      setSnackBar(true,"error","This tool is not allowed as it is already licensed.");
      setLoading(false);
      return false;
    }
    setToolId(selectedId);   

    return true;
  };
  const handleCloseNewLicenseModel = () => {
    clearLicenseFields();
    setUpdateOrAddLicense(false);
    setIsConvertLicense(false);
    setIsDisabledInRenew(false);
    setShowNewLicenseModel(false);
  }

  const handleCloseEditQuantityModel = () => {
    handleCloseNewLicenseModel();
    setShowEditQuantityModel(false);
  }

  const handleTransTypeSelection = (e) => {
    const selectedId = e.target.value;
    setTransactionTypeId(selectedId);
    // const oneYearFromNow = new Date();
    const today = dayjs()

    const oneYearFromNow = dayjs(today.add(1, "year").format("YYYY-MM-DD"));
    const twoMonthsFromNow = dayjs(today.add(2, "month").format("YYYY-MM-DD"));
    const isTrial =  transactionTypesList.find(transactionType => transactionType.transactionTypeId === selectedId).transactionTypeText.includes("Trial");

    setExpiryDateValue(isTrial ? twoMonthsFromNow: oneYearFromNow);
    if(isTrial) setQuantity(1);

    return true;
  };

  const controlInvoiceAmount = ((e) => {
    if (!/[0-9]/.test(e.key)) {
      if(!['Backspace','Delete','ArrowLeft','ArrowRight','Home','End','Tab'].includes(e.key)) {
        e.preventDefault();
        return false;
      }                   
    }
  })

  /**
   * search customer list
   */
  const handleSearch = _.debounce(function (val) {
    setSearchValue(val?.toLowerCase());
  }, 700);

  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid item container xs={12} md={12} className="page-content">        
        <Grid container item xs={3} md={3} className="page-menu customers-left-filter-panel"  >
        <Grid item container xs={12} md={11} >
        <TextField                
                id="search"
                variant="standard"
                placeholder="Search" 
                style={{'border-bottom':'2px solid #617080'}}               
                InputProps={{
                  startAdornment: (
                    <InputAdornment  position="start">
                      <SearchOutlined/>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleSearch(e.target.value)}
                autoComplete={"off"}
              />
          </Grid>
          
          <Card className="filter-pane-scroll" style={{minWidth: 275,marginTop: 30,minHeight:330}}>
            <Typography className="filter-label" gutterBottom>
              Filters
            </Typography>            
            <Accordion style={FilterTypeGrid} defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="status-content"
                id="status-header"
                style={filterAccordionSummary}
              >
                <Typography className="filter-type-label">{("Market")}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid>
                  <Grid style={centerDivContainer}>
                    <Checkbox
                      value="all"
                      onChange={(event) => handleMarketsCheckbox(event, isAllMarketsSelected)}
                      checked={isAllMarketsSelected}
                    />
                    <Typography className="filter-type-item">{("SELECT ALL")}</Typography>
                  </Grid>
                  {salesOfficeBasedMarketsList && salesOfficeBasedMarketsList.map((list, i) => {
                    const checked = marketsCheckbox.some((data) => {
                      return list.marketName === data.marketName;
                    });

                    return (
                      <Grid key={i} style={checkboxLabel}>
                        <Checkbox
                          value={list.marketName}
                          onChange={(event) => handleMarketsCheckbox(event, list)}
                          checked={checked}
                        />
                        <Grid
                          sx={{
                            position: "relative",
                            top: 10,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Typography className="filter-type-item">{list.marketName}</Typography>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </AccordionDetails>
            </Accordion> 
            <Accordion style={FilterTypeGrid} defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="sites-content"
                id="sites-header"
                style={filterAccordionSummary}
              >
                <Typography className="filter-type-label">{("Expiration Date")}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0px 36px 0px 0px" }}>
                <Grid>
               
                  {expirationDatesList && expirationDatesList.map((list, i) => {
                    const checked = expirationDateCheckbox.some((data) => {
                      return list.expiryName === data.expiryName;
                    });

                    return (
                      <Grid key={i} style={checkboxLabel}>
                        <Checkbox
                          value={list.expiryName}
                          onChange={(event) => handleExpirationDateCheckbox(event, list)}
                          checked={checked}
                        />
                        <Grid
                          sx={{
                            position: "relative",
                            top: 10,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Typography className="filter-type-item">{list.expiryName}</Typography>
                        </Grid>
                      </Grid>
                    );
                  })}                  
                </Grid>
              </AccordionDetails>
            </Accordion>
            <Accordion style={FilterTypeGrid} defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="sites-content"
                id="sites-header"
                style={filterAccordionSummary}
              >
                <Typography className="filter-type-label">{("Status")}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0px 36px 0px 0px" }}>
                <Grid>
                  {statusList && statusList.map((list, i) => {
                    const checked = statusCheckbox.some((data) => {
                      return list.statusName === data.statusName;
                    });

                    return (
                      <Grid key={i} style={checkboxLabel}>
                        <Checkbox
                          value={list.statusName}
                          onChange={(event) => handleStatusCheckbox(event, list)}
                          checked={checked}
                        />
                        <Grid
                          sx={{
                            position: "relative",
                            top: 10,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Typography className="filter-type-item">{list.statusName}</Typography>
                        </Grid>
                      </Grid>
                    );
                  })}                  
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Card>
        </Grid>
        <Grid container item xs={9} md={9} className="page-menu">
          {/* <Card style= {{ width: '100%', padding: 10 }}>  */}
          <Grid item container xs={12} md={11} justify="flex-end">
            <CustomButton
              id="newModel"
              showGradient={true}
              variant="contained"
              color="primary"
              disabled={false}
              name="Add Customer"
              onClick={onNewProjectClick}
            />
          </Grid>
          {gridData?.length == 0 &&      
          <Grid item container xs={12} md={11}>
            <Typography className="filter-label" gutterBottom>No Results Found</Typography>
          </Grid>
          }
          
          <Grid item container xs={12} md={11}>
            {gridData?.length > 0 && (
              <CustomerGrid
                key={Math.random()}
                headers={MODELS_CONTROLS.GRID_HEADERS}
                headerClassName={classes.gridHeaderColumns}
                data={sortedData}
                loading={loading}
                selectedPage={modelState.selectedPage}
                onPageSelection={onSelectedPage}
                sortCol={sortCol}
                sortKey={sortKey}
                sortType={sortType}
                onSortChange={handleSortChange}
              />
            )} </Grid>
          {/* </Card> */}
            {/* Fix for https://carrierengg.atlassian.net/browse/EDESIGN-12858 */}
          <DMDeleteDialog
            open={showDelete}
            onClose={() => setShowDelete(false)}
            contentText={`${companyName} will be deleted.`}
            discardText={"Cancel"}
            agreeText={"Ok"}
            onProceed={() => {
              deleteConfirm(deleteCustomerId);
            }}
          />

        </Grid>

        {/* Dialog for unsave chabges warning */}
        <DMDeleteDialog
          open={unsaveChangePopup}
          onClose={() => setUnsaveChangePopup(false)}
          title={"Warning"}
          contentText={`You have unsaved changes, On close you will loose all your changes. Are you sure you want to close?`}
          discardText={"Cancel"}
          agreeText={"Yes"}
          onProceed={() => {
            onCloseSelected({
              id: "",
              isClosed: true,
            });
            setUnsaveChangePopup(false);
            setIsUnsaveChanges(false);
          }}
        />






        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
            setShowMoreOptions(false);
          }}
        >
        </Menu>

        <div>      
          <Drawer  open={drawerOpen} className={`parent-popup ${(showNewContact || showNewLicenseModel || showEditQuantityModel) ? classes.disableClicks : ""}`} anchor="right" onClose={toggleDrawer(false)}>
            {DrawerList}
          </Drawer>
        </div>



        <DMModal open={showSendEmailModel} onClose={() => setShowSendEmailModel(false)}>
          <div style={modalStyle} className={classes.emailCardPaper}>
            <div>
            <h3 id="simple-modal-title" style={{margin:'1px',paddingBottom:'5px' }}>{editCustomerId? "Edit" : ""} Send License Email </h3>
              <Typography className={classes.headerLabelStyle}>To: {email}</Typography>
              <Typography className={classes.headerLabelStyle}>Subject: {subject}</Typography>
              </div>
              <div>
              <Card variant="outlined" className={classes.cardContainer}>
                    <CardContent>
                        <div height='200px' overflow= 'auto' dangerouslySetInnerHTML={{ __html: htmlContent }} /> 
                    </CardContent>
              </Card>
              </div>
            <div style={{ display: "flex",marginTop:"50%",flexDirection: "row", gap: 5 }}>
            <Grid
                item
                xs={12}
                container
                style={{ justifyContent: "center" }}
              >
                <Grid item xs={6} style={{ paddingLeft: '35%',justifyContent: "center", alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowSendEmailModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleEmailSendTo}                   
                    className="makeStyles-gradient-27"
                  >
                    Send
                  </Button>
                </Grid>
              </Grid>
                    </div>
              {/* </div> */}
              </div>
        </DMModal>
    
        <DMModal open={showNewModel} onClose={() => setShowNewModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title" style={{margin:'1px',paddingBottom:'5px'}}>{editCustomerId? "Edit" : "New"} Customer</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>

              <TextField
                id="outlined-basic-companyName"
                label="Company Name*"
                variant="outlined"
                type="text"
                value={companyName}  
                autoComplete="off"              
                inputProps={{style: {height:'0.5px'}}}                            
                onChange={(e) => setCompanyName(e.target.value)}                
              />
              <TextField
                id="outlined-basic-companyName"
                label="Customer Number*"
                variant="outlined"
                type="number"
                value={customerNumber}  
                autoComplete="off"              
                inputProps={{style: {height:'0.5px'}}}                                            
                onKeyDown={(e) => {                  
                  if (!/[0-9]/.test(e.key)) {
                    if(['Backspace','Delete','ArrowLeft','ArrowRight','Home','End','Tab'].includes(e.code)) {
                      return true;
                    }else{
                      e.preventDefault();
                      return false;
                    }                    
                  }
                }}
                onChange={(e) => setCustomerNumber(e.target.value)}
              />
              <TextField
                id="outlined-basic-companyType"
                select
                labelId="company-type-select-required-label"
                label="Company Type*"
                variant="outlined"
                value={companyTypeId}                
                inputProps={{style: {height:'0.5px'}}}            
                onChange={(e)=>setCompanyTypeId(e.target.value)}
                placeholder="Company Type"
              >               
              {companyTypeList.length > 0 && companyTypeList.map((company) => {
                  return (
                    <MenuItem key={company.companyTypeId} value={company.companyTypeId}>
                      {company.companyTypeText}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                id="outlined-basic-markId"
                select
                labelId="markId-select-required-label"
                label="Market*"
                variant="outlined"
                value={newModel?.marketId}                
                inputProps={{style: {height:'0.5px'}}}
                onChange={handleMarketNewModel}
                placeholder="Market"
              >
              {salesOfficeBasedMarketsList.length > 0 && salesOfficeBasedMarketsList.map((market) => {
                  return (
                    <MenuItem key={market.marketId} value={market.marketId}>
                      {market.marketName}
                    </MenuItem>
                  );
                })}
              </TextField>
  
          
          {!editCustomerId ? (<h3 id="simple-modal-title" style={{margin:1}}>Contact</h3>): ""}
          {
            !editCustomerId ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 5,isDisabled:true }}>
              <TextField
                id="outlined-basic-customerName"
                label="Name*"
                variant="outlined"
                type="text"
                autoComplete="off"              
                value={contactName}                
                inputProps={{style: {height:'0.5px'}}}            
                onChange={(e) => setContactName(e.target.value)}
              />
              <TextField
                id="outlined-basic-contactEmail"
                label="Email*"
                variant="outlined"
                type="email"
                autoComplete="off"              
                value={contactEmail}                
                inputProps={{style: {height:'0.5px'}}}            
                onChange={(e) => setContactEmail(e.target.value)}
              />
              <TextField
                id="outlined-basic-jobPosition"
                label="Job Position"
                variant="outlined"
                type="text"
                value={jobPosition} 
                autoComplete="off"                             
                inputProps={{style: {height:'0.5px'}}}            
                onChange={(e) => setJobPosition(e.target.value)}
              />
              <TextField
                id="outlined-basic-phoneNumber"
                label="Phone Number"
                variant="outlined"
                type="text"
                value={phoneNumber}  
                autoComplete="off"                            
                inputProps={{style: {height:'0.5px'}}}            
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>  
            ) : "" }
              <Grid
                item
                xs={9}
                container
                style={{ justifyContent: "center" }}
              >
                <Grid item xs={6} style={{ paddingLeft: '25%',justifyContent: "center", alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowNewModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} style={{paddingLeft:'15%'}}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleCreateModel}                   
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            
            
          </div>
          </div>
        </DMModal>

        {/* MAIN CONTACT */}
        <DMModal open={showNewContact} onClose={() => setShowNewContact(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title" style={{margin:'1px',paddingBottom:'5px'}}>{!customerContactId ? "New" : "Edit"} Contact</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
              <TextField
                id="outlined-basic-customerName"
                label="Name*"
                variant="outlined"
                type="text"
                value={contactName}                
                inputProps={{style: {height:'0.5px'}}}            
                onChange={(e) => setContactName(e.target.value)}
              />
              <TextField
                id="outlined-basic-contactEmail"
                label="Email*"
                variant="outlined"
                type="email"
                value={contactEmail}                
                inputProps={{style: {height:'0.5px'}}}            
                onChange={(e) => setContactEmail(e.target.value)}
              />
              <TextField
                id="outlined-basic-jobPosition"
                label="Job Position"
                variant="outlined"
                type="text"
                value={jobPosition}                
                inputProps={{style: {height:'0.5px'}}}            
                onChange={(e) => setJobPosition(e.target.value)}
              />
              <TextField
                id="outlined-basic-phoneNumber"
                label="Phone Number"
                variant="outlined"
                type="text"
                value={phoneNumber}                
                inputProps={{style: {height:'0.5px'}}}            
                onChange={(e) => setPhoneNumber(e.target.value)}
              />

        <div style={{ display: "flex", flexDirection: "row",paddingLeft: 5}}>
          <div style={{ display: "flex", flexDirection: "column",alignContent: 'flex-start',width:'10px'}}>
            <Checkbox
              value= {isDefaultContact}
              onChange={(e) => setIsDefaultContact(e.target.checked)}              
              style={{width:25}}
              checked={isDefaultContact}                          
            /> 
          </div>
          <div style={{ display: "flex", flexDirection: "column",alignContent: 'flex-end',paddingTop: 13,paddingLeft:15}}>
            <Typography className="filter-type-item">Define as Main Contact</Typography>
          </div>
        </div>        

                        <Grid
                          sx={{
                            position: "relative",
                            top: 10,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >

                   
                        
              <Grid
                item
                xs={9}
                container
                style={{ justifyContent: "center" }}
              >
                <Grid item xs={6} style={{ justifyContent: "center", alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      setShowNewContact(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleNewContact}                   
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
              </Grid>
          </div>
          </div>
        </DMModal>
        {/* END CONTACT */}

        {/* NEW LICENSE Popup */}
        <DMModal open={showNewLicenseModel} onClose={() => handleCloseNewLicenseModel()}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title" style={{margin:'1px',paddingBottom:'8px'}}>{renewLicenseId? "Renew" : ( isConvertLicense? "Convert" : "New")} License</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <TextField
                id="" 
                disabled={isDisabledInRenew}
                select
                labelId="tools-select-required-label"
                label="Tool *"
                variant="outlined"
                value={toolId} 
                inputProps={{style: {height:'0.5px'}}}            
                onChange={handleToolSelection}                
              > 
                            
              {toolsDropdownList.length > 0 && toolsDropdownList.map((tools) => {                
                  return (
                    <MenuItem key={tools.toolId} value={tools.toolId}>
                      {tools.toolName}
                    </MenuItem>
                  );
                })}
              </TextField>
              
              <TextField
                id="" 
                disabled={isDisabledInRenew}
                select
                labelId="transactionType-select-required-label"
                label="Transaction Type *"
                variant="outlined"
                defaultValue={transactionTypeId}
                value={transactionTypeId}                
                inputProps={{style: {height:'0.5px'}}}            
                onChange={handleTransTypeSelection}
              > 
                        {transactionTypesList.length > 0 && transactionTypesList.map((trans) => {
                          if(!renewLicenseId && trans.transactionTypeText != 'Renewal'){
                            return <MenuItem key={trans.transactionTypeId} value={trans.transactionTypeId}>{trans.transactionTypeText}</MenuItem>
                          }else if(renewLicenseId){
                            return <MenuItem key={trans.transactionTypeId} value={trans.transactionTypeId}>{trans.transactionTypeText}</MenuItem>
                          }
                        })}
              </TextField>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker 
                    label="Expiration Date *"
                    value={expiryDateValue}
                    onChange={(newValue) => {                      
                      setExpiryDateValue(newValue);
                    }}
                    //renderInput={(params) => <TextField {...params} />}                    
                    slotProps={{ 
                      textField: { 
                        sx: { width: '100%' }
                      }
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <TextField
                id="outlined-basic-discounts"
                select
                labelId="discounts-select-required-label"
                label="Discount Used *"
                variant="outlined"
                defaultValue="0"
                value={discountId} 
                inputProps={{style: {height:'0.5px'}}}            
                onChange={handleDiscountsSelection}
                placeholder="Discount"
              >                             
              
              {renewlicenseDiscountsIds.length > 0 && renewlicenseDiscountsIds.map((item) => {
                if(renewLicenseId){
                  var addMenu = [];
                  if(item.discountId == "0"){
                    addMenu.push(<MenuItem key="0" value="0">No Discount</MenuItem>)
                  }
                  else{
                    const discountInfo = discountsList.find((list) => item.discountId === list.discountId);
                    addMenu.push(<MenuItem key={discountInfo.discountId} value={discountInfo.discountId}>
                                      {discountInfo.discountLabel}
                                    </MenuItem>)
                  }
                  return addMenu;
                }
              })}
              
              {newlicenseDiscountsIds.length > 0 && newlicenseDiscountsIds.map((item) => {
                if(!renewLicenseId){
                var addMenu = []; 
                if(item.discountId == "0"){
                  addMenu.push(<MenuItem key="0" value="0">No Discount</MenuItem>)
                }else{
                  const discountInfo = discountsList.find((list) => item.discountId === list.discountId); 
                  addMenu.push(<MenuItem key={discountInfo.discountId} value={discountInfo.discountId}>
                                    {discountInfo.discountLabel}
                                  </MenuItem>)
                }
                return addMenu;
                }
              })}
      
              </TextField>     

              <div style={{ display: "flex",marginTop:2, flexDirection: "row", gap: 5 }}>
              <TextField
                id="outlined-basic-qty"
                label="Quantity"
                variant="outlined"
                style={{width:'65%'}}
                disabled={true}
                type="text"
                value={quantity}                
                inputProps={{style: {height:'0.5px'}}}                            
                onKeyDown={(e) => {                  
                  
                }}
                onChange={(e) => setQuantity(e.target.value)}              
              />

                {(!isDisabledInRenew || isConvertLicense) && (
                  <div>
                    <RemoveOutlinedIcon style={{backgroundColor: '#8080802e', marginLeft: 50, cursor: 'pointer'}}
                                        onClick={() => {handleDecChangeQty();}}/>
                    <AddRoundedIcon style={{backgroundColor: '#8080802e', marginLeft: 30, cursor: 'pointer'}}
                                    onClick={() => {handleIncChangeQty();}}/>
                  </div>
                )}


              </div>
              <div style={{display: "flex", borderTop: '1px solid grey', flexDirection: "row", gap: 5}}>
                <div style={{display: "flex", flexDirection: "column"}}>
                  <Typography className="calcprice" gutterBottom>Calculated Price
                    ({localStorage.getItem("currencySymbolValue")})</Typography>
              <Typography className="calcpricevalue" gutterBottom>{calculatedPrice}</Typography>
            </div>
            <div  style={{ display: "flex", flexDirection: "column", marginLeft:50, marginTop:10,backgroundColor: '#D9EAFD'}}>
            <Typography className="invoiceamt" gutterBottom>Invoiced Amount ({localStorage.getItem("currencySymbolValue")})</Typography> 
            {/* <Typography className="invoiceamtvalue" gutterBottom>{invoicedAmount}</Typography> */}

            <TextField
                id="outlined-basic-invoicedamt"
                label="Invoiced Amount *"
                variant="outlined"
                style={{width:'95%'}}
                type="text"
                value={invoicedAmount}                
                inputProps={{style: {height:'0.5px'}}}
                onKeyDown={controlInvoiceAmount}                            
                onChange={(e) => setInvoicedAmount(e.target.value)}              
              />
            </div>
            </div>
            <div style={{ display: "flex",flexDirection: "row", gap: 5 }}>           
                <Grid item xs={6} style={{ paddingLeft: '25%',justifyContent: "center", alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      handleCloseNewLicenseModel();
                      setShowNewLicenseModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleCreateLicense}                   
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
           
            </div>
            
          </div>
          </div>
        </DMModal>
          
          {/* OPEN EDIT QUANTITY PANEL */}
        <DMModal open={showEditQuantityModel} onClose={() => handleCloseEditQuantityModel()}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title" style={{margin:'1px',paddingBottom:'15px'}}>Edit Quantity</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>

              
              <TextField
                id="outlined-basic-discounts"
                select
                disabled={true}
                labelId="discounts-select-required-label"
                label="Discount Used"
                variant="outlined"
                defaultValue="0"
                value={discountId} 
                inputProps={{style: {height:'0.5px'}}}            
                onChange={getEditQtyDiscountsCalculatedPrice}
                placeholder="Tool"
              >                             


              return (<MenuItem key="0" value="0">No Discount</MenuItem>);



              </TextField>  

    <div style={{ display: "flex",marginTop:2, flexDirection: "row", gap: 5 }}>
              <TextField
                id="outlined-basic-qty"
                label="Quantity"
                disabled={true}
                variant="outlined"
                style={{width:'65%'}}
                type="text"
                value={quantity}                
                inputProps={{style: {height:'0.5px'}}}
              />
              <RemoveOutlinedIcon style={{backgroundColor: '#8080802e',marginLeft:50}} onClick={() => {handleDecChangeQty();}} />
              <AddRoundedIcon style={{backgroundColor: '#8080802e',marginLeft:30}} onClick={() => {handleIncChangeQty();}} />
              
                </div>
            <div style={{ display: "flex",marginTop:10,borderTop:'1px solid grey', flexDirection: "row", gap: 5 }}>
            <div style={{ display: "flex", flexDirection: "column"}}> 
              <Typography className="calcprice" gutterBottom>Calculated Price ({localStorage.getItem("currencySymbolValue")})</Typography>                       
              <Typography className="calcpricevalue" gutterBottom>{calculatedPrice} </Typography>
            </div>
            <div  style={{ display: "flex", flexDirection: "column", marginLeft:50, marginTop:10,backgroundColor: '#D9EAFD'}}>
            <Typography className="invoiceamt" gutterBottom>Invoiced Amount ({localStorage.getItem("currencySymbolValue")})</Typography> 
            {/*<Typography className="invoiceamtvalue" gutterBottom>{invoicedAmount} </Typography> */}
            <TextField
                id="outlined-basic-invoicedamt"
                label="Invoiced Amount"
                variant="outlined"
                style={{width:'95%'}}
                type="text"
                value={invoicedAmount}                
                inputProps={{style: {height:'0.5px'}}}
                onKeyDown={(e) => {                  
                  if (!/[0-9]/.test(e.key)) {
                    if(['Backspace','Delete','ArrowLeft','ArrowRight','Home','End','Tab'].includes(e.code)) {
                      return true;
                    }else{
                      e.preventDefault();
                      return false;
                    }                    
                  }
                }}                            
                onChange={(e) => setInvoicedAmount(e.target.value)}              
              />
            </div>
            </div>
            <div style={{ display: "flex",marginTop:15,flexDirection: "row", gap: 5 }}>
              <Grid item xs={6} style={{ paddingLeft: '25%',justifyContent: "center", alignItems: "center" }}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsDisabled(true);
                      handleCloseEditQuantityModel();
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick= {() => { handleEditLicenseQuantity() }}
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>            
            </div>
          </div>
          </div>
        </DMModal>
      </Grid>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={() => setShowAlert(false)}
      >
        <Alert onClose={() => setShowAlert(false)} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};


 const mapStateToProps = (state) => ({  
  modelState: state.customersList,  
  salesOfficeData : state.model.tripleScreen.sales || [],
  currencyState: state.model.currency,
  discountOfferedState: state.discountList.discountsOfferList.data || [],
  toolsOfferedState: state.toolOffered.tools.data || [],
  toolState: state.tool.tools.data || [],
  salesOfficeList: state.usersList.users.salesOfficeList || [],
  salesOfficeBasedMarketsList: state.customersList.customers.salesOfficeBasedMarketsList || [],
  expirationDatesList: state.customersList.customers.expirationDatesList || [],
  statusList: state.customersList.customers.statusList || [],
  customersList: state.customersList.customers.customersList || [],  
  companyTypeList: state.customersList.customers.companyTypeList || [],
  renderCustomersListData: state.customersList.renderCustomersListData || [],  
  marketsCheckbox: state.customersList.marketsCheckbox || [],
  expirationDateCheckbox: state.customersList.expirationDateCheckbox || [],
  statusCheckbox: state.customersList.statusCheckbox || [],
  createNewCustomer : state.customersList.createNewCustomer,
  updateQuantity: state.customersList.updateQuantity,  
  updateCustomer: state.customersList.updateCustomer,  
  deleteCustomer: state.customersList.deleteCustomer,  
  generateNewLicense : state.customersList.generateNewLicense,
  renewalLicense : state.customersList.renewalLicense,
  createNewLicense: state.customersList.createNewLicense || [],
  discountsList: state.customersList.customers.discountsList || [],  
  transactionTypesList: state.customersList.customers.transactionTypesList || [],
  licenseByCustomerList: state.customersList.customers.licenseByCustomerList || [],
  transactionByCustomerList: state.customersList.customers.transactionByCustomerList || [],
  contactsByCustomerList: state.customersList.customers.contactsByCustomerList || [],
  createNewContact : state.customersList.createNewContact,
  deleteCustomerContact: state.customersList.deleteCustomerContact,
  updateCustomerContact: state.customersList.updateCustomerContact,
}); 

const mapDispatchToProps = (dispatch) => {
  return {    
    getExpirationDatesList: async () => dispatch(customerActions.getExpirationDatesList()),
    getStatusList: async () => dispatch(customerActions.getStatusList()),
    getCustomersList: async (salesOfficeId) => dispatch(customerActions.getCustomersList(salesOfficeId)),    
    getCompanyTypeList: async () => dispatch(customerActions.getCompanyTypeList()),
    getCurrency: async() => dispatch(modelAction.getCurrency()),
    getSalesOfficeList: async () => dispatch(userActions.getSalesOfficeList()),
    getTools: async () => dispatch(toolAction.getTools()),
    getTransactionTypesList: async () => dispatch(customerActions.getTransactionTypesList()),        
    getDiscountsList: async () => dispatch(customerActions.getDiscountsList()),
    getDiscountsOffered: async (retriveSalesOfficeId) => dispatch(discountsOfferedAction.getDiscountsOffered(retriveSalesOfficeId)),
    createNewLicenseAction:  async (requestPayload) =>
      dispatch(customerActions.createNewLicenseAction(requestPayload)),
    generateNewLicenseAction: async (requestPayload) =>
      dispatch(customerActions.generateNewLicenseAction(requestPayload)),    
    updateQuantityAction: async (requestPayload,params) =>
      dispatch(customerActions.updateQuantityAction(requestPayload,params)),     
    getToolsOffered: async (retriveSalesOfficeId) => dispatch(toolsOfferedAction.getToolsOffered(retriveSalesOfficeId)),   
    getModels: async () => dispatch(modelAction.getModels()),
    deleteModel: async (requestPayload) =>
      dispatch(modelAction.deleteModel(requestPayload)),
    createNewModel: async (requestPayload) =>
      dispatch(modelAction.createNewModel(requestPayload)),
    createNewCustomer: async (requestPayload) =>
      dispatch(customerActions.createNewCustomer(requestPayload)),
    createNewContactByCustomer: async (requestPayload) =>
      dispatch(customerActions.createNewContactByCustomer(requestPayload)),
    updateModel: async (requestPayload) =>
      dispatch(modelAction.updateModel(requestPayload)),    
    onMoreOptionsSelected: (modelId) =>
      dispatch(miscAction.onModelSelected(modelId)),
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onPageSelected: (selectedPage) =>
      dispatch(modelAction.setModelSelectedPage(selectedPage)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),    
    getSelectedMarketsData: (marketsCheckbox) => dispatch(customerActions.getSelectedMarketsData(marketsCheckbox)),
    getSelectedExpirationDatesData: (expirationDateCheckbox) => dispatch(customerActions.getSelectedExpirationDatesData(expirationDateCheckbox)),
    getSelectedStatusData: (statusCheckbox) => dispatch(customerActions.getSelectedStatusData(statusCheckbox)),    
    getRenderCustomersListData: (renderCustomersListData) => dispatch(customerActions.getRenderCustomersListData(renderCustomersListData)),
    renewalLicenseAction: (requestPayload) => dispatch(customerActions.renewalLicenseAction(requestPayload)),    
    updateCustomerAction: (requestPayload) => dispatch(customerActions.updateCustomerAction(requestPayload)),
    deleteCustomerAction: (requestPayload) => dispatch(customerActions.deleteCustomerAction(requestPayload)),
    deleteCustomerContactAction: (requestPayload) => dispatch(customerActions.deleteCustomerContactAction(requestPayload)),
    updateCustomerContactAction: (requestPayload) => dispatch(customerActions.updateCustomerContactAction(requestPayload)),
    getSalesOfficeBasedMarketsList: (salesOfficeId) => dispatch(customerActions.getSalesOfficeBasedMarketsList(salesOfficeId)),
    getLicenseByCustomer: (customerId) => dispatch(customerActions.getLicenseByCustomer(customerId)),
    getTransactionByCustomer: (customerId) => dispatch(customerActions.getTransactionByCustomer(customerId)),
    getContactsByCustomer:  (customerId) => dispatch(customerActions.getContactsByCustomer(customerId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Customers);